import { gql } from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Decimal: any;
  Domain: any;
  Email: any;
  ISO8601Date: any;
  ISO8601DateTime: any;
  IpAddress: any;
  JSON: any;
  PhoneNumber: any;
  Url: any;
};

export type IAsn = {
  __typename?: 'ASN';
  /** Alerts associated with the ASN */
  alerts?: Maybe<Array<IAsnAlert>>;
  asnIdentifier: Scalars['String'];
  asnItems: Array<IAsnItem>;
  asnType: IAsnTypeEnum;
  brand: IBrand;
  brandId: Scalars['ID'];
  /** Indicates whether the ASN can be sent to the WMS. */
  canBeSentToWms: Scalars['Boolean'];
  carrierType: IAsnCarrierTypeEnum;
  createdAt: Scalars['ISO8601DateTime'];
  expectedArrivalDate?: Maybe<Scalars['ISO8601Date']>;
  /** The ASN ID in the external system. If this value is present, it means the ASN was created in an external system. */
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lineItemsCount: Scalars['Int'];
  notes?: Maybe<Array<INote>>;
  poNumber: Scalars['String'];
  receivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  shipDate?: Maybe<Scalars['ISO8601Date']>;
  shippingCarrierService?: Maybe<Scalars['ID']>;
  status: IAsnStatus;
  statusName: IAsnStatusEnum;
  totalUnits: Scalars['Int'];
  trackingNumber: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
  warehouse?: Maybe<IWarehouse>;
  warehouseId?: Maybe<Scalars['ID']>;
  /** Link to the WMS for the ASN. This field is only available if the ASN can be sent to the WMS and the `externalId` is present. */
  wmsUrl?: Maybe<Scalars['Url']>;
};

/** Autogenerated input type of ASNAddReceivingItem */
export type IAsnAddReceivingItemInput = {
  /** The ID of the ASN to which the line item will be added. */
  asnId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the location where the product will be stored. */
  destinationLocationId?: InputMaybe<Scalars['ID']>;
  /** The product ID. If not provided, the system will use the SKU. */
  productId?: InputMaybe<Scalars['ID']>;
  /** The received quantity of the product. */
  quantity: Scalars['Int'];
  /** The product SKU. If not provided, the system will use the product ID. */
  sku?: InputMaybe<Scalars['String']>;
};

/** The ASN alert object that contains information about an alert associated with an ASN. */
export type IAsnAlert = {
  __typename?: 'ASNAlert';
  additionalInfo?: Maybe<Scalars['String']>;
  alertCode: Scalars['String'];
  /** The order object of the status. */
  asn: IAsn;
  asnId: Scalars['ID'];
  id: Scalars['ID'];
  message: Scalars['String'];
  severity: IAsnAlertSeverityEnum;
  solution?: Maybe<Scalars['String']>;
};

export enum IAsnAlertSeverityEnum {
  /** Error */
  Error = 'ERROR',
  /** Information */
  Info = 'INFO',
  /** Warning */
  Warning = 'WARNING'
}

export type IAsnAvailableItem = {
  __typename?: 'ASNAvailableItem';
  brandId: Scalars['ID'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  image?: Maybe<IProductImage>;
  name: Scalars['String'];
  sku?: Maybe<Scalars['String']>;
  status: IProductStatusEnum;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Autogenerated input type of ASNCancel */
export type IAsnCancelInput = {
  asnId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The carrier type for the ASN. */
export enum IAsnCarrierTypeEnum {
  /** Air */
  Air = 'AIR',
  /** Ocean */
  Ocean = 'OCEAN',
  /** Other */
  Other = 'OTHER',
  /** Truck */
  Truck = 'TRUCK'
}

/** Autogenerated input type of ASNClose */
export type IAsnCloseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the ASN to close. */
  id: Scalars['ID'];
};

/** The connection type for ASN. */
export type IAsnConnection = {
  __typename?: 'ASNConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IAsnEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IAsn>>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** Total count of items in the connection, without considering pagination. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type IAsnEdge = {
  __typename?: 'ASNEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<IAsn>;
};

/** Represents a filtering option for ASNs. */
export type IAsnFilter = {
  __typename?: 'ASNFilter';
  asnTypes?: Maybe<Array<IFilterOption>>;
  brands?: Maybe<Array<IFilterOption>>;
  buildings?: Maybe<Array<IFilterOption>>;
  carrierTypes?: Maybe<Array<IFilterOption>>;
  statuses?: Maybe<Array<IFilterOption>>;
};

/** Filtering options for ASNs. */
export type IAsnFilterInput = {
  /** Filter ASNs by type. */
  asnTypes?: InputMaybe<Array<IAsnTypeEnum>>;
  /** Filter ASNs by brand ID. */
  brandIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Filter ASNs by carrier type. */
  carrierTypes?: InputMaybe<Array<IAsnCarrierTypeEnum>>;
  /** Filter ASNs with expected arrival date before this date. */
  expectedEndDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Filter ASNs with expected arrival date after this date. */
  expectedStartDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Filter ASNs by keyword. */
  keyword?: InputMaybe<Scalars['String']>;
  /** Filter ASNs created before this date. */
  shipEndDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Filter ASNs created after this date. */
  shipStartDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Field to sort the ASNs by. */
  sortBy?: InputMaybe<IAsnSortFieldEnum>;
  /** Type of sort (ASC or DESC). */
  sortOrder?: InputMaybe<ISortTypeEnum>;
  /** Filter ASNs by status. */
  statuses?: InputMaybe<Array<IAsnStatusEnum>>;
  /** Filter ASNs by warehouse ID. */
  warehouseIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type IAsnItem = {
  __typename?: 'ASNItem';
  asn: IAsn;
  asnId: Scalars['ID'];
  createdAt: Scalars['ISO8601DateTime'];
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  destinationLocation?: Maybe<ILocation>;
  destinationLocationId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  inventoryItem?: Maybe<IInventoryItem>;
  inventoryItemId?: Maybe<Scalars['ID']>;
  product: IProduct;
  productId: Scalars['ID'];
  quantity: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
  verified: Scalars['Boolean'];
  verifiedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The party who verified the item. */
  verifiedBy?: Maybe<IParty>;
  verifiedById?: Maybe<Scalars['ID']>;
  verifiedQuantity?: Maybe<Scalars['Int']>;
};

/** The input object for an ASN item. */
export type IAsnItemInput = {
  /** If this is set to true, the system will delete the ASN item. If this is provided, the `id` field must be provided as well and other fields will be ignored. */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** The ASN item ID. If this is provided, the system will update the existing ASN item. If this is not provided, the system will create a new ASN item. */
  id?: InputMaybe<Scalars['ID']>;
  /** The product ID. If not provided, the system will use the SKU. */
  productId?: InputMaybe<Scalars['ID']>;
  /** The quantity of the product. */
  quantity?: InputMaybe<Scalars['Int']>;
  /** The product SKU. If not provided, the system will use the product ID */
  sku?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of ASNSendToWms */
export type IAsnSendToWmsInput = {
  /** Contains the ASN id(s) */
  asnIds: Array<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of ASNSendToWms. */
export type IAsnSendToWmsPayload = {
  __typename?: 'ASNSendToWmsPayload';
  asnIds: Array<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  status: IStatusResultEnum;
};

/** Fields to sort ASNs by. */
export enum IAsnSortFieldEnum {
  /** ASN Type */
  AsnType = 'ASN_TYPE',
  /** Building */
  Building = 'BUILDING',
  /** Carrier Type */
  CarrierType = 'CARRIER_TYPE',
  /** Created At */
  CreatedAt = 'CREATED_AT',
  /** Expected Arrival Date */
  ExpectedArrivalDate = 'EXPECTED_ARRIVAL_DATE',
  /** Identifier */
  Identifier = 'IDENTIFIER',
  /** Items Count */
  ItemsCount = 'ITEMS_COUNT',
  /** PO Number */
  PoNumber = 'PO_NUMBER',
  /** Received At */
  ReceivedAt = 'RECEIVED_AT',
  /** Ship Date */
  ShipDate = 'SHIP_DATE',
  /** Status Name */
  StatusName = 'STATUS_NAME',
  /** Total Units */
  TotalUnits = 'TOTAL_UNITS',
  /** Tracking Number */
  TrackingNumber = 'TRACKING_NUMBER',
  /** Updated At */
  UpdatedAt = 'UPDATED_AT',
  /** Warehouse Name */
  WarehouseName = 'WAREHOUSE_NAME'
}

export type IAsnStatus = {
  __typename?: 'ASNStatus';
  asnId: Scalars['ID'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name: IAsnStatusEnum;
  updatedAt: Scalars['ISO8601DateTime'];
  withChanges: Scalars['Boolean'];
};

/** The status of the ASN. */
export enum IAsnStatusEnum {
  /** Arrived */
  Arrived = 'ARRIVED',
  /** Canceled */
  Canceled = 'CANCELED',
  /** Closed */
  Closed = 'CLOSED',
  /** Incoming */
  Incoming = 'INCOMING',
  /** In Receiving */
  Receiving = 'RECEIVING'
}

/** The type of ASN. */
export enum IAsnTypeEnum {
  /** Quick ASN */
  QuickAsn = 'QUICK_ASN',
  /** Return */
  Return = 'RETURN',
  /** Standard */
  Standard = 'STANDARD'
}

/** Autogenerated input type of ASNUpdateReceivingItem */
export type IAsnUpdateReceivingItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The new destination location ID for the line item. */
  destinationLocationId?: InputMaybe<Scalars['ID']>;
  /** The ID of the ASN line item to update. The line item must belong to the ASN that is being updated. */
  itemId: Scalars['ID'];
  /** The new quantity received for the line item. If not provided, the quantity will not be updated. */
  quantity?: InputMaybe<Scalars['Int']>;
  /** The new verification status of the line item. If not provided, the verification status will not be updated. */
  verified?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated input type of AcceptPersonInvitation */
export type IAcceptPersonInvitationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  token: Scalars['String'];
};

/** Autogenerated return type of AcceptPersonInvitation. */
export type IAcceptPersonInvitationPayload = {
  __typename?: 'AcceptPersonInvitationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The recently verified login identifier. */
  loginIdentifier?: Maybe<Scalars['String']>;
  /** The type of login identifier verified. */
  loginIdentifierType?: Maybe<ILoginIdentifierTypesEnum>;
  /** Result of the attempt to verification. A successful response means that the login identifier was verified. */
  status: Scalars['String'];
};

/** Autogenerated input type of AddColor */
export type IAddColorInput = {
  brandId?: InputMaybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  colorCode?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  status?: InputMaybe<IProductStatusEnum>;
};

/** Autogenerated input type of AddNote */
export type IAddNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The content of the note. */
  content: Scalars['String'];
  /** The ID of the object that the note is attached to. */
  notableId: Scalars['ID'];
  /** The type of the object that the note is attached to. */
  notableType: INotableObjectEnum;
};

/** Autogenerated input type of AddOrderItem */
export type IAddOrderItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the order to add the item to */
  orderId: Scalars['ID'];
  /** The price of the product to add to the order */
  price?: InputMaybe<Scalars['Decimal']>;
  /** The ID of the product to add to the order */
  productId: Scalars['ID'];
  /** The quantity of the product to add to the order */
  quantity: Scalars['Int'];
};

/** Autogenerated input type of AddProduct */
export type IAddProductInput = {
  /** The ID of the brand to which this product belongs. If not provided, the current brand will be used. */
  brandId?: InputMaybe<Scalars['ID']>;
  /** The bullet points for this product. Bullet points are used to describe the product on the website. */
  bulletPoints?: InputMaybe<Array<Scalars['String']>>;
  /** The IDs of the categories to which this product belongs. */
  categories?: InputMaybe<Array<Scalars['ID']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  colorId?: InputMaybe<Scalars['ID']>;
  customsInput?: InputMaybe<IProductCustomsInput>;
  description?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Decimal']>;
  images?: InputMaybe<Array<IProductImageInput>>;
  /** Whether this product has an inner pack. If true, the inner pack data must be provided. */
  innerPack?: InputMaybe<Scalars['Boolean']>;
  innerPackInput?: InputMaybe<IProductInnerPackInput>;
  length?: InputMaybe<Scalars['Decimal']>;
  /** Whether this product has a master carton. If true, the master carton data must be provided. */
  masterCarton?: InputMaybe<Scalars['Boolean']>;
  masterCartonInput?: InputMaybe<IProductMasterCartonInput>;
  name: Scalars['String'];
  /** Whether this product has a pallet. If true, the pallet data must be provided. */
  pallet?: InputMaybe<Scalars['Boolean']>;
  palletInput?: InputMaybe<IProductPalletInput>;
  /** The ID of the parent product. If provided, this product will be a variant of the parent product. */
  parentId?: InputMaybe<Scalars['ID']>;
  price?: InputMaybe<Scalars['Decimal']>;
  /** The type of product. If not provided, defaults to 'BASE_ITEM'. */
  productType?: InputMaybe<IProductTypeEnum>;
  purchasingInput?: InputMaybe<IProductPurchasingInput>;
  /** Whether this product is shippable. If false, the product will not be available for purchase. */
  ship?: InputMaybe<Scalars['Boolean']>;
  shippingInput?: InputMaybe<IProductShippingInput>;
  sizeId?: InputMaybe<Scalars['ID']>;
  sku: Scalars['String'];
  status?: InputMaybe<IProductStatusEnum>;
  styleId?: InputMaybe<Scalars['ID']>;
  upc?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Decimal']>;
  width?: InputMaybe<Scalars['Decimal']>;
};

/** Autogenerated input type of AddRelationship */
export type IAddRelationshipInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  effectiveFrom?: InputMaybe<Scalars['ISO8601DateTime']>;
  effectiveTo?: InputMaybe<Scalars['ISO8601DateTime']>;
  partyFromId: Scalars['ID'];
  partyToId: Scalars['ID'];
  relationshipType: IRelationshipTypesEnum;
};

/** Autogenerated input type of AddRole */
export type IAddRoleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** This argument is optional. It is used to describe the role type. */
  description?: InputMaybe<Scalars['String']>;
  /** This argument is required. Indicates the domain of the role type. The domain is used to the system to know in which context the role type is applicable. For instance, a role type with domain set to "BRAND" is only applicable to brands and cannot be used in other contexts. */
  domain: IDomainEnum;
  /** This argument is required and it will be used to handle the role type in the system.The role type name must be unique on must not contain spaces or special characters. */
  name: Scalars['String'];
  /** This argument is required. It is used to indicate the party types that can be assigned to the role type. */
  partyTypes: Array<IPartyTypeEnum>;
  /** This argument is used to display the role type in a more user friendly way. */
  prettyName: Scalars['String'];
};

/** Autogenerated input type of AddSize */
export type IAddSizeInput = {
  brandId?: InputMaybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  status?: InputMaybe<IProductStatusEnum>;
};

/** Autogenerated input type of AddStyle */
export type IAddStyleInput = {
  brandId?: InputMaybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  parentId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<IProductStatusEnum>;
};

/** The address type is used to represent a structured address. */
export type IAddress = {
  __typename?: 'Address';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  buildingType?: Maybe<IAddressBuildingTypeEnum>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  formattedAddress?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export enum IAddressBuildingTypeEnum {
  /** Commercial */
  Commercial = 'COMMERCIAL',
  /** Residential */
  Residential = 'RESIDENTIAL'
}

/** The address input is used to register a new address or update an existing one. */
export type IAddressInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  buildingType?: InputMaybe<IAddressBuildingTypeEnum>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  formattedAddress?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of AllocateOrder */
export type IAllocateOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderId: Scalars['ID'];
};

export type IAllowedRole = {
  __typename?: 'AllowedRole';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  partyType: IParty;
  partyTypeName: Scalars['String'];
  roleName: Scalars['String'];
  roleType: IRoleType;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type IApiClient = {
  __typename?: 'ApiClient';
  apiKeys: Array<IApiKey>;
  company: ICompany;
  createdAt: Scalars['ISO8601DateTime'];
  details: IApiClientDetails;
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for ApiClient. */
export type IApiClientConnection = {
  __typename?: 'ApiClientConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IApiClientEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IApiClient>>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** Total count of items in the connection, without considering pagination. */
  totalCount: Scalars['Int'];
};

export type IApiClientDetails = {
  __typename?: 'ApiClientDetails';
  clientType: IApiClientTypeEnum;
  code: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** An edge in a connection. */
export type IApiClientEdge = {
  __typename?: 'ApiClientEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<IApiClient>;
};

/**
 * Type of API Client. Delegated clients are able to act on behalf of the user, while limited clients have restricted access to the API.
 *
 * Normally, a delegated client is a mobile or web app, while a limited client is a server-to-server integration.
 */
export enum IApiClientTypeEnum {
  /** Delegated Client */
  Delegated = 'DELEGATED',
  /** Limited Client */
  Limited = 'LIMITED'
}

export enum IApiClientsSortFieldEnum {
  /** Sort by status */
  ClientType = 'CLIENT_TYPE',
  /** Sort by integration_type */
  Code = 'CODE',
  /** Sort by created_at */
  CreatedAt = 'CREATED_AT',
  /** Sort by name */
  Name = 'NAME',
  /** Sort by updated_at */
  UpdatedAt = 'UPDATED_AT'
}

export type IApiKey = {
  __typename?: 'ApiKey';
  accessToken: Scalars['String'];
  activeUntil?: Maybe<Scalars['ISO8601DateTime']>;
  apiClient: IApiClient;
  apiKey: Scalars['String'];
  apiSecret: Scalars['String'];
  authorizedHosts?: Maybe<Array<Scalars['Url']>>;
  authorizedIps?: Maybe<Array<Scalars['IpAddress']>>;
  baseUrl?: Maybe<Scalars['Url']>;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  status: IStatusEnum;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Autogenerated input type of AssignRole */
export type IAssignRoleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The domain of the entity to assign the role to. This can be either the system, a company or a brand. */
  domain: IDomainEnum;
  domainEntityId?: InputMaybe<Scalars['ID']>;
  /** The party id of the person or integration to assign the role to. */
  partyId: Scalars['ID'];
  roleTypeName: IRoleTypeEnum;
};

export type IBrand = {
  __typename?: 'Brand';
  company: IParty;
  companyId: Scalars['ID'];
  createdAt: Scalars['ISO8601DateTime'];
  /** Indicates if the brand is the current brand specified in the context. */
  current?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  logoUrl?: Maybe<Scalars['Url']>;
  name?: Maybe<Scalars['String']>;
  responsible: IParty;
  responsibleId: Scalars['ID'];
  status: IBrandStatusEnum;
  updatedAt: Scalars['ISO8601DateTime'];
  /** Default warehouse associated with the brand. */
  warehouse?: Maybe<IWarehouse>;
  /** ID of the default warehouse associated with the brand. */
  warehouseId?: Maybe<Scalars['ID']>;
  websiteUrl?: Maybe<Scalars['Url']>;
};

export enum IBrandStatusEnum {
  /** Brand is active */
  Active = 'ACTIVE',
  /** Brand is inactive */
  Inactive = 'INACTIVE'
}

export enum IBuildingTypeEnum {
  /** External 3PL */
  External = 'EXTERNAL',
  /** In House */
  InHouse = 'IN_HOUSE',
  /** Other */
  Other = 'OTHER'
}

/** Autogenerated input type of BulkFulfillOrders */
export type IBulkFulfillOrdersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderIds: Array<Scalars['ID']>;
};

/** Autogenerated return type of BulkFulfillOrders. */
export type IBulkFulfillOrdersPayload = {
  __typename?: 'BulkFulfillOrdersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  orderIds: Array<Scalars['ID']>;
  status: IStatusResultEnum;
};

/** Autogenerated input type of CancelOrder */
export type ICancelOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderId: Scalars['ID'];
};

/** Autogenerated return type of CancelOrder. */
export type ICancelOrderPayload = {
  __typename?: 'CancelOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  status: IStatusResultEnum;
};

/** This type represents a carrier. A carrier is a company that provides shipping services. */
export type ICarrier = {
  __typename?: 'Carrier';
  brandId?: Maybe<Scalars['ID']>;
  category: ICarrierCategoryEnum;
  code: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  description?: Maybe<Scalars['String']>;
  global: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  status: IStatusEnum;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** This enum represents the category of a carrier. The category can be express, ground, or freight. */
export enum ICarrierCategoryEnum {
  /** Auto carrier */
  Auto = 'AUTO',
  /** Bulk carrier */
  Bulk = 'BULK',
  /** Cold chain carrier */
  ColdChain = 'COLD_CHAIN',
  /** Courier carrier */
  Courier = 'COURIER',
  /** Freight carrier */
  Freight = 'FREIGHT',
  /** Logistics carrier */
  Logistics = 'LOGISTICS',
  /** Luxury carrier */
  Luxe = 'LUXE',
  /** Other carrier */
  Other = 'OTHER',
  /** Perishable carrier */
  Perishable = 'PERISHABLE',
  /** General carrier */
  Standard = 'STANDARD'
}

/** A mapping between an external carrier and a carrier in our system. */
export type ICarrierMapping = {
  __typename?: 'CarrierMapping';
  /** The carrier this mapping is for. */
  carrier: ICarrier;
  /** The code for the carrier our system. */
  carrierCode: Scalars['String'];
  carrierId: Scalars['ID'];
  /** The code for the carrier in the external system. */
  clientCode?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  /** The integration that will use this mapping. */
  integration?: Maybe<IIntegration>;
  integrationId?: Maybe<Scalars['ID']>;
  /** The type of the integration that will use this mapping. */
  integrationType: IIntegrationTypeEnum;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** This type represents a carrier service. A carrier service is a service offered by a carrier to ship orders. */
export type ICarrierService = {
  __typename?: 'CarrierService';
  carrier: ICarrier;
  carrierId: Scalars['ID'];
  code: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  status: IStatusEnum;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type ICarrierServiceMapping = {
  __typename?: 'CarrierServiceMapping';
  carrierService: ICarrierService;
  carrierServiceCode: Scalars['String'];
  carrierServiceId: Scalars['ID'];
  clientCode: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  integration?: Maybe<IIntegration>;
  integrationId?: Maybe<Scalars['ID']>;
  integrationType: IIntegrationTypeEnum;
  updatedAt: Scalars['ISO8601DateTime'];
};

export enum ICategoryFieldsEnum {
  CreatedAt = 'created_at',
  Description = 'description',
  Id = 'id',
  Name = 'name',
  ParentId = 'parent_id',
  Status = 'status',
  UpdatedAt = 'updated_at'
}

/** Filtering options for product categories. */
export type ICategoryFilterInput = {
  brandId?: InputMaybe<Scalars['ID']>;
  categoryType?: InputMaybe<ICategoryTypeEnum>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<IProductStatusEnum>;
};

export enum ICategoryTypeEnum {
  /** All */
  All = 'ALL',
  /** Sub Category */
  Child = 'CHILD',
  /** Root Category */
  Root = 'ROOT'
}

/** Autogenerated input type of CloneProduct */
export type ICloneProductInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The name of the new product. If not provided, the name of the original product will be used. */
  name?: InputMaybe<Scalars['String']>;
  /** The ID of the product to clone. */
  productId: Scalars['ID'];
  /** The SKU of the new product. If not provided, the SKU of the original product will be used. */
  sku?: InputMaybe<Scalars['String']>;
};

/** A color */
export type IColor = {
  __typename?: 'Color';
  brand?: Maybe<IBrand>;
  colorCode?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  status: IProductStatusEnum;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type ICompany = {
  __typename?: 'Company';
  createdAt: Scalars['ISO8601DateTime'];
  /** Indicates if the party is the current selected party. This field applies only for companies. */
  current?: Maybe<Scalars['Boolean']>;
  /** The details of the party. The details are different for every party type. For example, a company has a name, a person has a first name and a last name. */
  details: ICompanyDetails;
  /** The relationships of the party in a human readable format. */
  humanizedRelationships?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  /** The type of party. Party can have different types and every type has different attributes. For example, a company has a name, a person has a first name and a last name. */
  partyType?: Maybe<Scalars['String']>;
  /** The relationships of the party. A relationship is a connection between two parties. For example, a person can be an employee of a company. */
  relationships: Array<IRelationship>;
  /** The persons responsible for the company. */
  responsibles?: Maybe<Array<IPerson>>;
  roles?: Maybe<Array<IRole>>;
  updatedAt: Scalars['ISO8601DateTime'];
  /** The user associated with the party. Only persons can have a user associated with them. */
  user?: Maybe<IUser>;
};

/** The connection type for Company. */
export type ICompanyConnection = {
  __typename?: 'CompanyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ICompanyEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ICompany>>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** Total count of items in the connection, without considering pagination. */
  totalCount: Scalars['Int'];
};

/** Details of a company */
export type ICompanyDetails = {
  __typename?: 'CompanyDetails';
  companyType?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner: IParty;
  ownerId: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** An edge in a connection. */
export type ICompanyEdge = {
  __typename?: 'CompanyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ICompany>;
};

/** Filter for companies. */
export type ICompanyFilterInput = {
  /** Filter by company type. This field is used to filter the companies by the type of the company. */
  companyType?: InputMaybe<ICompanyTypesEnum>;
  /** Filter by keyword. This field is used to filter the notes by the name of the company. */
  keyword?: InputMaybe<Scalars['String']>;
};

/** Possible types for companies */
export enum ICompanyTypesEnum {
  Customer = 'CUSTOMER',
  Threepl = 'THREEPL'
}

/** Autogenerated input type of CompleteForgotPassword */
export type ICompleteForgotPasswordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** New password to set. */
  newPassword: Scalars['String'];
  /** Token received in the email. */
  token: Scalars['String'];
};

/** Autogenerated return type of CompleteForgotPassword. */
export type ICompleteForgotPasswordPayload = {
  __typename?: 'CompleteForgotPasswordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  status: IStatusResultEnum;
};

/** A country */
export type ICountry = {
  __typename?: 'Country';
  createdAt: Scalars['ISO8601DateTime'];
  currencyCode?: Maybe<Scalars['String']>;
  currencyName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** The "ISO 2" field denotes the two-letter country code assigned by the International Organization for Standardization (ISO). */
  iso2: Scalars['String'];
  /** The "ISO 3" field denotes the three-letter country code assigned by the International Organization for Standardization (ISO). */
  iso3: Scalars['String'];
  /** The "ISO Numeric" field denotes the numeric country code assigned by the International Organization for Standardization (ISO). */
  isoNumeric: Scalars['String'];
  name: Scalars['String'];
  /** The "Postal Code Reg" field denotes the regular expression used to validate postal codes for a country. */
  postalCodeRegex?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Filter countries by name, ISO 2 code, or ISO 3 code */
export type ICountryFiltersInput = {
  /** The keyword to search for in the country's name, ISO 2 code, or ISO 3 code */
  keyword?: InputMaybe<Scalars['String']>;
  /** The field to sort countries by */
  sortBy?: InputMaybe<ICountrySortByEnum>;
  /** The direction to sort countries by */
  sortType?: InputMaybe<ISortTypeEnum>;
};

export enum ICountrySortByEnum {
  /** Name */
  CreatedDate = 'CREATED_DATE',
  /** Name */
  Currency = 'CURRENCY',
  /** Name */
  CurrencyCode = 'CURRENCY_CODE',
  /** Name */
  Iso2 = 'ISO2',
  /** Name */
  Iso3 = 'ISO3',
  /** Name */
  IsoNumeric = 'ISO_NUMERIC',
  /** Name */
  Name = 'NAME',
  /** Name */
  UpdatedDate = 'UPDATED_DATE'
}

/** Autogenerated input type of CreateASN */
export type ICreateAsnInput = {
  /** The items that are part of the ASN. */
  asnItems?: InputMaybe<Array<IAsnItemInput>>;
  /** The type of ASN. */
  asnType: IAsnTypeEnum;
  /** The brand ID for the ASN. If not provided, the brand ID will be extracted from the `X-Brand-Id` header. */
  brandId?: InputMaybe<Scalars['ID']>;
  /** The carrier type for the ASN. */
  carrierType: IAsnCarrierTypeEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The expected arrival date for the ASN. */
  expectedArrivalDate?: InputMaybe<Scalars['ISO8601Date']>;
  /** The notes that are part of the ASN. */
  notes?: InputMaybe<Array<INoteInput>>;
  /** The PO number for the ASN. */
  poNumber: Scalars['String'];
  /** The ship date for the ASN. */
  shipDate?: InputMaybe<Scalars['ISO8601Date']>;
  /** The carrier service used by the ASN. */
  shippingCarrierService?: InputMaybe<Scalars['String']>;
  /** The tracking number for the ASN. This tracking number must be unique in the brand context. */
  trackingNumber: Scalars['String'];
  /** The destination warehouse ID for the ASN. */
  warehouseId: Scalars['ID'];
};

/** Autogenerated input type of CreateApiKey */
export type ICreateApiKeyInput = {
  /** The date and time when the API key will expire. If not provided, the API key will never expire. */
  activeUntil?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The ID of the API client for which the API key is being created. */
  apiClientId: Scalars['ID'];
  /** The list of authorized hosts for the API key. This option only applies to API clients that are web applications. */
  authorizedHosts?: InputMaybe<Array<Scalars['Domain']>>;
  /** The list of authorized IP addresses for the API key. This option only applies to API clients that are server-side applications. */
  authorizedIps?: InputMaybe<Array<Scalars['IpAddress']>>;
  /** The base URL for the API client. Emails notifications and other communications will use this URL as base for links. */
  baseUrl?: InputMaybe<Scalars['Url']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** A descriptive name for the API key. */
  name: Scalars['String'];
};

/** Autogenerated input type of CreateLocation */
export type ICreateLocationInput = {
  brandId?: InputMaybe<Scalars['ID']>;
  buildingType: IBuildingTypeEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Set this location as the default pick location for the warehouse */
  defaultPick?: InputMaybe<Scalars['Boolean']>;
  locationType: ILocationTypeEnum;
  mixing?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pickable?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<IStatusEnum>;
  warehouseId: Scalars['ID'];
  zone: IZoneEnum;
};

/** Autogenerated input type of CreateOrder */
export type ICreateOrderInput = {
  /** The address where the bill will be sent to. */
  billToAddress?: InputMaybe<IAddressInput>;
  /** The company of the person who will receive the bill. */
  billToCompany?: InputMaybe<Scalars['String']>;
  /** The email of the person who will receive the bill. */
  billToEmail?: InputMaybe<Scalars['String']>;
  /** The name of the person who will receive the bill. */
  billToName?: InputMaybe<Scalars['String']>;
  /** The phone of the person who will receive the bill. */
  billToPhone?: InputMaybe<Scalars['String']>;
  /** The brand ID. This parameter is optional, but if not provided, you should provide the header 'X-Brand-Id' with the brand ID. */
  brandId?: InputMaybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The expected delivery date for the order. */
  expectedDeliveryDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The expected ship date for the order. */
  expectedShipDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The financial status of the order. The default value is `PAID`. */
  financialStatus?: InputMaybe<IOrderFinancialStatusEnum>;
  /** The items that are part of the order. */
  orderItems?: InputMaybe<Array<IOrderItemInput>>;
  /** The metadata that is part of the order. This metadata can be used to store additional information about the order. For example, data received from an external system. */
  orderMetadata?: InputMaybe<Scalars['JSON']>;
  /** The notes that are part of the order. */
  orderNotes?: InputMaybe<Array<INoteInput>>;
  /** The order number. This order number must be unique in the brand context. If not provided, the system will generate a unique order number. */
  orderNumber?: InputMaybe<Scalars['String']>;
  /** The tags that are part of the order. */
  orderTags?: InputMaybe<Array<IOrderTagInput>>;
  /** The order ID from the external system. This parameter is optional, but if provided, it must be unique in the brand context. */
  originOrderId?: InputMaybe<Scalars['String']>;
  /** The responsible ID for the order. This parameter is optional, but if provided, it should be a party id and the party must be a person. */
  responsibleId?: InputMaybe<Scalars['ID']>;
  /** The sales channel ID for the order.  */
  salesChannelId: Scalars['ID'];
  /** The selected carrier ID for the order. This parameter is optional, but if provided, it should be a carrier id. */
  selectedCarrierId?: InputMaybe<Scalars['ID']>;
  /** The selected service ID for the order. This parameter is optional, but if provided, it should be a service id. */
  selectedCarrierServiceId?: InputMaybe<Scalars['ID']>;
  /** The company of the person who will receive the order. */
  shipToCompany?: InputMaybe<Scalars['String']>;
  /** The email of the person who will receive the order. */
  shipToEmail?: InputMaybe<Scalars['String']>;
  /** The name of the person who will receive the order. */
  shipToName?: InputMaybe<Scalars['String']>;
  /** The phone of the person who will receive the order. */
  shipToPhone?: InputMaybe<Scalars['String']>;
  /** Indicates if the bill to address is the same as the ship to address. */
  shipToSameAsBillTo?: InputMaybe<Scalars['Boolean']>;
  /** The address where the order will be shipped to. */
  shippingAddress?: InputMaybe<IAddressInput>;
  /** The requested shipping carrier service. */
  shippingCarrierService?: InputMaybe<Scalars['String']>;
  /** The shipping cost paid by the customer. */
  shippingCost?: InputMaybe<Scalars['Decimal']>;
  /** The status of the new order. The initial status is limited to `draft` or `ordered`. To change the status, you must process the order first. */
  status?: InputMaybe<INewOrderStatusEnum>;
  /** The total tax for the order. */
  totalTax?: InputMaybe<Scalars['Decimal']>;
};

/** Autogenerated input type of CreateSalesChannel */
export type ICreateSalesChannelInput = {
  /** Whether orders from this sales channel should be automatically fulfilled. */
  autoFulfill?: InputMaybe<Scalars['Boolean']>;
  /** The brand that the sales channel belongs to. If not provided, the header `X-Brand-Id` will be used. */
  brandId?: InputMaybe<Scalars['ID']>;
  channelType?: InputMaybe<ISalesChannelTypeEnum>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  codeName?: InputMaybe<Scalars['String']>;
  customPackingSlip?: InputMaybe<Scalars['Boolean']>;
  /** Whether this is the default sales channel for the brand. If this options is set to true, the default sales channel for the brand will be updated. */
  defaultChannel?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  /** Whether the routing strategy is local or global. If this value is set to true, Endless Commerce will manage the routing for orders from this sales channel. If this value is set to false, the routing strategy will be managed by the external system integrated with Endless Commerce. */
  localRouting?: InputMaybe<Scalars['Boolean']>;
  logoUrl?: InputMaybe<Scalars['Url']>;
  name: Scalars['String'];
  origin?: InputMaybe<ISalesChannelOriginEnum>;
  /** The routing strategy to be used for this sales channel. If not provided, the default routing strategy will be used. */
  routingStrategy?: InputMaybe<Array<IRoutingStrategyEnum>>;
  status?: InputMaybe<IStatusEnum>;
};

export type ICustoms = {
  __typename?: 'Customs';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  defaultValue?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  origin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type IDeletedResponse = {
  __typename?: 'DeletedResponse';
  additionalInfo?: Maybe<Scalars['JSON']>;
  deletedAt: Scalars['ISO8601DateTime'];
  result: IStatusResultEnum;
};

/** The depth of the inventory item */
export enum IDepthEnum {
  /** Full Stock */
  FullStock = 'FULL_STOCK',
  /** Low Stock */
  LowStock = 'LOW_STOCK',
  /** Out of Stock */
  OutOfStock = 'OUT_OF_STOCK',
  /** Oversold */
  Oversold = 'OVERSOLD'
}

/** Available domains for roles. */
export enum IDomainEnum {
  /** Line of business domain */
  Brand = 'BRAND',
  /** Company domain */
  Company = 'COMPANY',
  /** System domain */
  System = 'SYSTEM'
}

/** Autogenerated input type of EditLinkedExternalData */
export type IEditLinkedExternalDataInput = {
  brandId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  integrationId: Scalars['ID'];
  objectType: Scalars['String'];
  /** Hash containing local object, external object, and action */
  payload: Array<IEditableExternalRelationInput>;
};

/** Autogenerated return type of EditLinkedExternalData. */
export type IEditLinkedExternalDataPayload = {
  __typename?: 'EditLinkedExternalDataPayload';
  brandId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  result: IStatusResultEnum;
};

/** The input object for editing/relinking an external relation. */
export type IEditableExternalRelationInput = {
  /** The ID of the external object. */
  externalObjectId?: InputMaybe<Scalars['ID']>;
  /** The ID of the local object. */
  localObjectId?: InputMaybe<Scalars['ID']>;
  /** The object type to have the action performed on. */
  objectType: Scalars['String'];
};

/** Used to return the details of a particular object in the external relations table */
export type IExternalObject = {
  __typename?: 'ExternalObject';
  id: Scalars['ID'];
  integrationId: Scalars['ID'];
  metadata: Scalars['JSON'];
  objectType: Scalars['String'];
};

/** External object type */
export enum IExternalObjectTypeEnum {
  /** Carrier */
  Carrier = 'CARRIER',
  /** Product */
  Product = 'PRODUCT',
  /** Sales Channel */
  SalesChannel = 'SALES_CHANNEL',
  /** Warehouse */
  Warehouse = 'WAREHOUSE'
}

/** This type represents a base external product. */
export type IExternalProducts = {
  __typename?: 'ExternalProducts';
  createdAt: Scalars['ISO8601DateTime'];
  externalId: Scalars['String'];
  externalUpdatedAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  integrationId: Scalars['ID'];
  metadata: Array<Scalars['String']>;
  productId: Scalars['ID'];
  syncedAt: Scalars['ISO8601DateTime'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The input object for the integration external/local object linking. */
export type IExternalRelationInput = {
  /** The desired action taken. */
  action: Scalars['String'];
  /** The ID of the external object. */
  externalObjectId?: InputMaybe<Scalars['ID']>;
  /** The ID of the local object. */
  localObjectId?: InputMaybe<Scalars['ID']>;
  /** The user's input. Currently utilized for carrier mappings */
  userInput?: InputMaybe<Scalars['String']>;
};

/** This type represents a base external sales channel */
export type IExternalSalesChannel = {
  __typename?: 'ExternalSalesChannel';
  createdAt: Scalars['ISO8601DateTime'];
  externalId: Scalars['String'];
  externalUpdatedAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  integrationId: Scalars['ID'];
  salesChannelId: Scalars['ID'];
  syncedAt: Scalars['ISO8601DateTime'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The type of external system that provides the data. */
export enum IExternalTypeEnum {
  /** Dropship */
  Dropship = 'DROPSHIP',
  /** Owned */
  Owned = 'OWNED'
}

/** This type represents a base external warehouse */
export type IExternalWarehouse = {
  __typename?: 'ExternalWarehouse';
  createdAt: Scalars['ISO8601DateTime'];
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  externalId: Scalars['String'];
  externalType: Scalars['String'];
  id: Scalars['ID'];
  integrationId: Scalars['ID'];
  metadata: Array<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  warehouseId: Scalars['ID'];
};

export type IFeatureFlagEnabled = {
  __typename?: 'FeatureFlagEnabled';
  enabled: Scalars['Boolean'];
  flagKey: Scalars['String'];
};

/** Represents a filtering option queries. */
export type IFilterOption = {
  __typename?: 'FilterOption';
  /** Extra information about the filter option. */
  extra?: Maybe<Scalars['String']>;
  /** The name of the filter option. */
  name: Scalars['String'];
  /** The value of the filter option. */
  value: Scalars['String'];
};

/** Autogenerated input type of FulfillOrder */
export type IFulfillOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderId: Scalars['ID'];
};

/** This type represents an item in an order fulfillment. Each item is associated with a product and a quantity */
export type IFulfillmentItem = {
  __typename?: 'FulfillmentItem';
  createdAt: Scalars['ISO8601DateTime'];
  fulfillment: IOrderFulfillment;
  fulfillmentId: Scalars['ID'];
  id: Scalars['ID'];
  location: ILocation;
  locationId: Scalars['ID'];
  orderItem: IOrderItem;
  orderItemId: Scalars['ID'];
  quantity: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Autogenerated input type of GetExternalShipment */
export type IGetExternalShipmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderId: Scalars['ID'];
};

/** Autogenerated return type of GetExternalShipment. */
export type IGetExternalShipmentPayload = {
  __typename?: 'GetExternalShipmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  status: IStatusResultEnum;
};

/** Autogenerated input type of HoldOrder */
export type IHoldOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The reason why the order is being held. */
  holdReason?: InputMaybe<Scalars['String']>;
  orderId: Scalars['ID'];
};

/** Autogenerated return type of HoldOrder. */
export type IHoldOrderPayload = {
  __typename?: 'HoldOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  holdReason?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
  status: IStatusResultEnum;
};

/** Autogenerated input type of ImportBrandCarriers */
export type IImportBrandCarriersInput = {
  brandId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of ImportBrandCarriers. */
export type IImportBrandCarriersPayload = {
  __typename?: 'ImportBrandCarriersPayload';
  brandId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  result: IStatusResultEnum;
};

/** Autogenerated input type of ImportExternalOrder */
export type IImportExternalOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the order in the external system. */
  externalOrderId: Scalars['String'];
  /** The ID of the sales channel where the order will be placed. This is used to determine the integration to use to import the order. */
  integrationId: Scalars['ID'];
};

/** Autogenerated return type of ImportExternalOrder. */
export type IImportExternalOrderPayload = {
  __typename?: 'ImportExternalOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The ID of the imported order. This ID can be used to query the order. */
  orderId?: Maybe<Scalars['ID']>;
  /** The status of the import process. */
  status: IProcessStatusEnum;
};

/** Autogenerated input type of InitInventoryTransfer */
export type IInitInventoryTransferInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the location from which the inventory is being transferred. */
  fromLocationId: Scalars['ID'];
  /**
   * The list of products to be transferred.Each product must have an ID and a quantity in the next format:
   * ```[{ itemId: "UUID", quantity: 10 }]```
   */
  items: Array<IInventoryItemTransferInput>;
  /** The reason for the inventory transfer. */
  reason: Scalars['String'];
  /** The ID of the location to which the inventory is being transferred. */
  toLocationId: Scalars['ID'];
};

/** Autogenerated input type of InitializeBrandInventory */
export type IInitializeBrandInventoryInput = {
  /** The ID of the brand for which the inventory is being initialized. */
  brandId?: InputMaybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of InitializeBrandInventory. */
export type IInitializeBrandInventoryPayload = {
  __typename?: 'InitializeBrandInventoryPayload';
  /** The ID of the brand for which the inventory was initialized. */
  brandId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The status of the operation. */
  status: IStatusResultEnum;
};

/** Autogenerated input type of InitializeInventory */
export type IInitializeInventoryInput = {
  /** The ID of the brand to which the product belongs. If not provided, the brand provided in the header `X-Brand-Id`. */
  brandId?: InputMaybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The inventory to initialize for the product at the location. */
  locationInventory: Array<ILocationInventoryInput>;
  /** The ID of the product to initialize inventory for. Either this or the SKU must be provided. */
  productId?: InputMaybe<Scalars['ID']>;
  /** The SKU of the product to initialize inventory for. Either this or the product ID must be provided. */
  sku?: InputMaybe<Scalars['String']>;
};

export type IInnerPack = {
  __typename?: 'InnerPack';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The "Dimensional Weight" field represents the calculated weight of a package based on its dimensions, which is used to determine shipping costs. This value is particularly relevant for items with large dimensions but relatively low actual weight. */
  dimWeight?: Maybe<Scalars['Decimal']>;
  gtin?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['ID']>;
  length?: Maybe<Scalars['Decimal']>;
  quantity?: Maybe<Scalars['Int']>;
  /** The "Rated Weight" of a product is a calculated attribute that indicates the estimated weight of the productand it is given by taking the max value between the dimensional weight and physical weight. */
  ratedWeight?: Maybe<Scalars['Decimal']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The "Volume" field denotes the amount of space occupied by a product in three dimensions (length, width, height). */
  volume?: Maybe<Scalars['Decimal']>;
  weight?: Maybe<Scalars['Decimal']>;
  weightFactor?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Decimal']>;
};

export type IIntegration = {
  __typename?: 'Integration';
  createdAt: Scalars['ISO8601DateTime'];
  /** The details of the party. The details are different for every party type. For example, a company has a name, a person has a first name and a last name. */
  details: IIntegrationDetails;
  id: Scalars['ID'];
  name: Scalars['String'];
  /** The type of party. Party can have different types and every type has different attributes. For example, a company has a name, a person has a first name and a last name. */
  partyType?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<IRole>>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type IIntegrationAction = {
  __typename?: 'IntegrationAction';
  /** The command to execute when the action is performed. This command must be sent in the `executeIntegrationAction` mutation. */
  command: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

/** The type of actions to return. If not provided, user actions will be returned. */
export enum IIntegrationActionEnum {
  /** Self actions */
  Self = 'SELF',
  /** User actions */
  User = 'USER'
}

/** The connection type for Integration. */
export type IIntegrationConnection = {
  __typename?: 'IntegrationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IIntegrationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IIntegration>>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** Total count of items in the connection, without considering pagination. */
  totalCount: Scalars['Int'];
};

/** Details for an integration. Integrations are used to connect to third-party services. For example, an integration with a sales platform like Shopify would allow you to import your sales data into MvnifestAI. */
export type IIntegrationDetails = {
  __typename?: 'IntegrationDetails';
  /** The API key for the integration. This field will be obfuscated when returned for security purposes. */
  apiKey?: Maybe<Scalars['String']>;
  /** The API secret for the integration. This field will be obfuscated when returned for security purposes. */
  apiSecret?: Maybe<Scalars['String']>;
  /** The API token for the integration. This field will be obfuscated when returned for security purposes. */
  apiToken?: Maybe<Scalars['String']>;
  brand?: Maybe<IBrand>;
  brandId?: Maybe<Scalars['ID']>;
  carrierMapping?: Maybe<Scalars['JSON']>;
  codeName: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  integrationType?: Maybe<IIntegrationTypeEnum>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['JSON']>;
  status?: Maybe<IStatusEnum>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** An edge in a connection. */
export type IIntegrationEdge = {
  __typename?: 'IntegrationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<IIntegration>;
};

/** Represents a filtering option for integrations. */
export type IIntegrationFilter = {
  __typename?: 'IntegrationFilter';
  brands?: Maybe<Array<IFilterOption>>;
  integrationType?: Maybe<Array<IFilterOption>>;
  statuses?: Maybe<Array<IFilterOption>>;
};

/** Filtering options for integrations */
export type IIntegrationFilterInput = {
  /** Brand IDs to filter integrations by. */
  brandIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Integration type to filter integrations by. */
  integrationType?: InputMaybe<Array<IIntegrationTypeEnum>>;
  /** Keyword to search for in integrations. This keyword will be searched in integration name, integration code, and integration description. */
  keyword?: InputMaybe<Scalars['String']>;
  /** Field to sort orders by. */
  sortField?: InputMaybe<IIntegrationSortFieldEnum>;
  /** Sort type for integrations. */
  sortType?: InputMaybe<ISortTypeEnum>;
  /** Status to filter integrations by. */
  status?: InputMaybe<Array<IStatusEnum>>;
};

export type IIntegrationSettingCategory = {
  __typename?: 'IntegrationSettingCategory';
  description?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  name: Scalars['String'];
  options?: Maybe<Array<IIntegrationSettingOption>>;
};

export type IIntegrationSettingOption = {
  __typename?: 'IntegrationSettingOption';
  default?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export enum IIntegrationSortFieldEnum {
  /** Sort by created_at */
  CreatedAt = 'CREATED_AT',
  /** Sort by integration_type */
  IntegrationType = 'INTEGRATION_TYPE',
  /** Sort by name */
  Name = 'NAME',
  /** Sort by status */
  Status = 'STATUS',
  /** Sort by updated_at */
  UpdatedAt = 'UPDATED_AT'
}

/** Integration type */
export type IIntegrationType = {
  __typename?: 'IntegrationType';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  prettyName: Scalars['String'];
  status: IStatusEnum;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Possible types of integrations. */
export enum IIntegrationTypeEnum {
  /** InfoPlus */
  Infoplus = 'INFOPLUS',
  /** Shipstation */
  Shipstation = 'SHIPSTATION',
  /** Shopify */
  Shopify = 'SHOPIFY',
  /** Trackstar */
  Trackstar = 'TRACKSTAR'
}

export type IInventoryAdjustmentReason = {
  __typename?: 'InventoryAdjustmentReason';
  code: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Represents a filtering option for locations in a warehouse. */
export type IInventoryFilter = {
  __typename?: 'InventoryFilter';
  /** The account filter options for inventory items. */
  account?: Maybe<Array<IFilterOption>>;
  /** The building filter options for inventory items. */
  building?: Maybe<Array<IFilterOption>>;
  /** The depth filter options for inventory items. */
  depth?: Maybe<Array<IFilterOption>>;
  /** The location filter options for inventory items. This field accepts as argument the building ID to filter the locations by. */
  location?: Maybe<Array<IFilterOption>>;
  productStatus?: Maybe<Array<IFilterOption>>;
};


/** Represents a filtering option for locations in a warehouse. */
export type IInventoryFilterLocationArgs = {
  buildingId?: InputMaybe<Array<Scalars['ID']>>;
};

/** Filtering options for inventory items. */
export type IInventoryFiltersInput = {
  /** Brand IDs to filter inventory items by. If not provided, the system will use, in order of priority, the current brand specified by the `X-Brand-Id` header, and lastly, the brands associated with the current party. */
  brandIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Building IDs to filter inventory items by. */
  buildingIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Depth to filter inventory items by. */
  depths?: InputMaybe<Array<Scalars['String']>>;
  /** Keyword to search for in the inventory items. This filters by name, sku, and UPC. */
  keyword?: InputMaybe<Scalars['String']>;
  /** Location IDs to filter inventory items by. */
  locationIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Status of the product. */
  productStatus?: InputMaybe<IStatusEnum>;
  /** Field to sort the inventory items by. */
  sortField?: InputMaybe<IInventorySortFieldsEnum>;
  /** Sort type for the inventory items. */
  sortType?: InputMaybe<ISortTypeEnum>;
};

/** The incoming inventory object represents the information of an ASN */
export type IInventoryIncoming = {
  __typename?: 'InventoryIncoming';
  asnId: Scalars['ID'];
  /** The ASN identifier associated with the incoming inventory */
  asnIdentifier: Scalars['String'];
  /** The ASN item object associated with the incoming inventory */
  asnItem: IAsnItem;
  /** The ASN type associated with the incoming inventory */
  asnType: IAsnTypeEnum;
  carrierType: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  expectedArrivalDate: Scalars['ISO8601Date'];
  poNumber: Scalars['String'];
  receivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  shipDate: Scalars['ISO8601Date'];
  shippingCarrierService: Scalars['String'];
  /** The status name associated with the incoming inventory */
  statusName: IAsnStatusEnum;
  trackingNumber: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** An inventory item */
export type IInventoryItem = {
  __typename?: 'InventoryItem';
  /** The allocated quantity of the inventory item.  */
  allocated: Scalars['Int'];
  /** The available quantity of the inventory item. Defined as the total quantity of an SKU that is available for sale. Available Inventory = Physical Inventory - Reserved */
  available: Scalars['Int'];
  /** The brand that the inventory item is for. */
  brand: IBrand;
  brandId: Scalars['ID'];
  /** When this inventory item was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** When this inventory item was deleted. */
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The depth of the inventory item. */
  depth: IDepthEnum;
  /** The ID of the inventory item. */
  id: Scalars['ID'];
  /** The incoming inventory items. These items represents ASN items that have not been closed. */
  incomingItems?: Maybe<Array<IInventoryIncoming>>;
  /** The locations that the inventory item is stored in. */
  inventoryLocations?: Maybe<Array<IItemLocation>>;
  /** The ordered quantity of the inventory item. Defined as the total quantity of an SKU that has been ordered by customers. */
  ordered: Scalars['Int'];
  /** The physical quantity of the inventory item. Defined as the total quantity of an SKU present in the building. Physical Inventory = Unavailable + In Stock */
  physical: Scalars['Int'];
  /** The product that the inventory item is for. */
  product: IProduct;
  productId: Scalars['ID'];
  /** The stock quantity of the inventory item. Defined as Physical Inventory - Unavailable. In Stock is also separated into Allocated + Unallocated */
  stock: Scalars['Int'];
  /** The unavailable quantity of the inventory item. Unavailable is the sum of Quarantine + Damaged units. */
  unavailable: Scalars['Int'];
  /** When this inventory item was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** An inventory item */
export type IInventoryItemAllocatedArgs = {
  warehouseId?: InputMaybe<Scalars['ID']>;
};


/** An inventory item */
export type IInventoryItemAvailableArgs = {
  warehouseId?: InputMaybe<Scalars['ID']>;
};


/** An inventory item */
export type IInventoryItemInventoryLocationsArgs = {
  filters?: InputMaybe<IInventoryLocationFilterInput>;
};


/** An inventory item */
export type IInventoryItemOrderedArgs = {
  warehouseId?: InputMaybe<Scalars['ID']>;
};


/** An inventory item */
export type IInventoryItemPhysicalArgs = {
  warehouseId?: InputMaybe<Scalars['ID']>;
};


/** An inventory item */
export type IInventoryItemStockArgs = {
  warehouseId?: InputMaybe<Scalars['ID']>;
};


/** An inventory item */
export type IInventoryItemUnavailableArgs = {
  warehouseId?: InputMaybe<Scalars['ID']>;
};

/** The connection type for InventoryItem. */
export type IInventoryItemConnection = {
  __typename?: 'InventoryItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IInventoryItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IInventoryItem>>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** Total count of items in the connection, without considering pagination. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type IInventoryItemEdge = {
  __typename?: 'InventoryItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<IInventoryItem>;
};

/** Attributes for adding a product to an inventory transfer */
export type IInventoryItemTransferInput = {
  /** The ID of the inventory item to transfer to the other location. */
  itemId: Scalars['ID'];
  /** The quantity of the inventory item to transfer to the other location. */
  quantity: Scalars['Int'];
};

/** Filtering options for locations for inventory. */
export type IInventoryLocationFilterInput = {
  /** ID of the warehouse to get locations for. */
  buildingId?: InputMaybe<Array<Scalars['ID']>>;
  locationType?: InputMaybe<Array<ILocationTypeEnum>>;
  mixing?: InputMaybe<Scalars['Boolean']>;
  pickable?: InputMaybe<Scalars['Boolean']>;
  /** Field to sort the locations by. */
  sortField?: InputMaybe<ILocationSortFieldsEnum>;
  /** Sort type for the locations. */
  sortType?: InputMaybe<ISortTypeEnum>;
  status?: InputMaybe<IStatusEnum>;
  zone?: InputMaybe<Array<IZoneEnum>>;
};

/** Autogenerated input type of InventoryQuickAdjust */
export type IInventoryQuickAdjustInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  itemId: Scalars['ID'];
  /** The reason for the inventory adjustment. This field should be a valid inventory adjustment reason ID. The reasons can be retrieved using the `inventoryAdjustmentReasons` query. */
  reason?: InputMaybe<Scalars['ID']>;
  /** The inventory adjustment values. These values represents the quantity to be added or removed from the inventory. */
  values: Array<ILocationInventoryInput>;
};

/** Inventory sorting fields */
export enum IInventorySortFieldsEnum {
  Available = 'AVAILABLE',
  Building = 'BUILDING',
  CreatedAt = 'CREATED_AT',
  Lob = 'LOB',
  Name = 'NAME',
  Ordered = 'ORDERED',
  Physical = 'PHYSICAL',
  Sku = 'SKU',
  Upc = 'UPC'
}

export type IInventoryTransfer = {
  __typename?: 'InventoryTransfer';
  createdAt: Scalars['ISO8601DateTime'];
  fromLocation: ILocation;
  id: Scalars['ID'];
  items: Array<ITransferItem>;
  reason: Scalars['String'];
  status: ITransferStatusEnum;
  toLocation: ILocation;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Autogenerated input type of InvitePerson */
export type IInvitePersonInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['ID']>;
  email: Scalars['Email'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  relationshipType?: InputMaybe<IRelationshipTypesEnum>;
};

/** The item allocation type represents the allocation information for an order item. */
export type IItemAllocation = {
  __typename?: 'ItemAllocation';
  /** The order item object that is allocated. */
  allocatedItem: IOrderItem;
  /** The flag that indicates if the item was already commited */
  committed: Scalars['Boolean'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  inventoryAllocationId: Scalars['ID'];
  /** The inventory item object of the allocation item. */
  inventoryItem: IInventoryItem;
  /** The location where the item is allocated. */
  location: ILocation;
  /** The location ID where the item is allocated. */
  locationId: Scalars['ID'];
  /** The quantity of the order item that is allocated. */
  quantity: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
  /** The warehouse where the item is allocated. */
  warehouse: IWarehouse;
  /** The warehouse ID where the item is allocated. */
  warehouseId: Scalars['ID'];
};

/** A location with inventory */
export type IItemLocation = {
  __typename?: 'ItemLocation';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  /** The inventory items stored in this location. */
  inventory: Array<IInventoryItem>;
  /** The details of the location in the warehouse. */
  location: ILocation;
  /** The stock level of the inventory item in this location. */
  stockLevel: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The sort field for the ASN items query. */
export enum IItemsSortByEnum {
  /** Sort by created at. */
  CreatedAt = 'CREATED_AT',
  /** Sort by name. */
  Name = 'NAME',
  /** Sort by SKU. */
  Sku = 'SKU'
}

/** Autogenerated input type of LinkExternalData */
export type ILinkExternalDataInput = {
  brandId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  integrationId: Scalars['ID'];
  objectType: Scalars['String'];
  /** Hash containing local object, external object, and action */
  payload: Array<IExternalRelationInput>;
};

/** Autogenerated return type of LinkExternalData. */
export type ILinkExternalDataPayload = {
  __typename?: 'LinkExternalDataPayload';
  brandId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  result: IStatusResultEnum;
};

export type ILocation = {
  __typename?: 'Location';
  buildingType: IBuildingTypeEnum;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  locationType: ILocationTypeEnum;
  mixing: Scalars['Boolean'];
  name: Scalars['String'];
  pickable: Scalars['Boolean'];
  status: IStatusEnum;
  updatedAt: Scalars['ISO8601DateTime'];
  warehouse: IWarehouse;
  warehouseId: Scalars['ID'];
  zone: IZoneEnum;
};

/** The connection type for Location. */
export type ILocationConnection = {
  __typename?: 'LocationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ILocationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ILocation>>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** Total count of items in the connection, without considering pagination. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ILocationEdge = {
  __typename?: 'LocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ILocation>;
};

/** Represents a filtering option for locations in a warehouse. */
export type ILocationFilter = {
  __typename?: 'LocationFilter';
  /**
   * The account filter options for locations in the warehouse.
   * @deprecated This field is deprecated and will be removed in the future. Accounts or Brands are not applicable to locations. Locations are objects that exists at the company level.
   */
  account?: Maybe<Array<IFilterOption>>;
  /** The building filter options for locations in the warehouse. */
  building?: Maybe<Array<IFilterOption>>;
  /** The company filter options for locations in the warehouse. */
  company?: Maybe<Array<IFilterOption>>;
  /** The location type filter options for locations in the warehouse. */
  locationType?: Maybe<Array<IFilterOption>>;
  /** The zone filter options for locations in the warehouse. */
  zone?: Maybe<Array<IFilterOption>>;
};

/** Filtering options for locations. */
export type ILocationFiltersInput = {
  brandIds?: InputMaybe<Array<Scalars['ID']>>;
  /** ID of the warehouse to get locations for. */
  buildingId?: InputMaybe<Array<Scalars['ID']>>;
  /** Keyword to search for in the locations. Will search by name, zone, building type, location type, and building name. This filter is case insensitive and should have a minimum length of 3 characters, if a keyword with less than 3 characters is provided, it will be ignored. */
  keyword?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Array<Scalars['ID']>>;
  locationType?: InputMaybe<Array<ILocationTypeEnum>>;
  mixing?: InputMaybe<Scalars['Boolean']>;
  pickable?: InputMaybe<Scalars['Boolean']>;
  /** Field to sort the locations by. */
  sortField?: InputMaybe<ILocationSortFieldsEnum>;
  /** Sort type for the locations. */
  sortType?: InputMaybe<ISortTypeEnum>;
  warehouseIds?: InputMaybe<Array<Scalars['ID']>>;
  zone?: InputMaybe<Array<IZoneEnum>>;
};

/** Product custom input */
export type ILocationInventoryInput = {
  /** The ID of the location to add the inventory to. */
  locationId: Scalars['ID'];
  /** The quantity of the product to add to the inventory. */
  quantity: Scalars['Int'];
};

/** Location sort fields */
export enum ILocationSortFieldsEnum {
  BuildingType = 'BUILDING_TYPE',
  CreatedAt = 'CREATED_AT',
  LocationType = 'LOCATION_TYPE',
  Mixing = 'MIXING',
  Name = 'NAME',
  Pickable = 'PICKABLE',
  Status = 'STATUS',
  UpdatedAt = 'UPDATED_AT',
  Zone = 'ZONE'
}

export enum ILocationTypeEnum {
  /** Bin */
  Bin = 'BIN',
  /** Cart */
  Cart = 'CART',
  /** Carton */
  Carton = 'CARTON',
  /** External */
  External = 'EXTERNAL',
  /** Pallet */
  Pallet = 'PALLET',
  /** Shelf */
  Shelf = 'SHELF',
  /** User */
  User = 'USER'
}

/** The `LogEntityTypeEnum` is used to filter the results of the SystemLog query. The value is the type of the entity associated with the log entry. */
export enum ILogEntityTypeEnum {
  /** ASN entity type. */
  Asn = 'ASN',
  /** Order entity type. */
  Inventory = 'INVENTORY',
  /** Order entity type. */
  Order = 'ORDER'
}

export enum ILogTypeEnum {
  /** Error log message */
  Error = 'ERROR',
  /** Informational log message */
  Info = 'INFO',
  /** Success log message */
  Success = 'SUCCESS',
  /** Warning log message */
  Warning = 'WARNING'
}

/** Types of possible identifiers to login. */
export enum ILoginIdentifierTypesEnum {
  Email = 'EMAIL'
}

/** The LogsPerformerType object represents a performer of a log entry. It includes fields for the ID and name of the performer. */
export type ILogsPerformer = {
  __typename?: 'LogsPerformer';
  /** The unique identifier for the performer. */
  id?: Maybe<Scalars['ID']>;
  /** The name of the performer. */
  name: Scalars['String'];
};

/** Autogenerated input type of MagicSignIn */
export type IMagicSignInInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};

/** Autogenerated return type of MagicSignIn. */
export type IMagicSignInPayload = {
  __typename?: 'MagicSignInPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /**
   * Returns the Bearer token to send in the `Authorization` header. Format this value as this:
   * `"Authorization": "Bearer {TOKEN}"`
   *
   */
  token: Scalars['String'];
  /** Expiration date time of the session token. */
  tokenExpiration: Scalars['ISO8601DateTime'];
  /** Logged user data. */
  user: IUser;
};

/** Autogenerated input type of MarkASNAsArrived */
export type IMarkAsnAsArrivedInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ASN ID to mark as arrived. */
  id: Scalars['ID'];
};

export type IMasterCarton = {
  __typename?: 'MasterCarton';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The "Dimensional Weight" field represents the calculated weight of a package based on its dimensions, which is used to determine shipping costs. This value is particularly relevant for items with large dimensions but relatively low actual weight. */
  dimWeight?: Maybe<Scalars['Decimal']>;
  gtin?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['ID']>;
  length?: Maybe<Scalars['Decimal']>;
  quantity?: Maybe<Scalars['Int']>;
  /** The "Rated Weight" of a product is a calculated attribute that indicates the estimated weight of the productand it is given by taking the max value between the dimensional weight and physical weight. */
  ratedWeight?: Maybe<Scalars['Decimal']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The "Volume" field denotes the amount of space occupied by a product in three dimensions (length, width, height). */
  volume?: Maybe<Scalars['Decimal']>;
  weight?: Maybe<Scalars['Decimal']>;
  weightFactor?: Maybe<Scalars['Decimal']>;
  width?: Maybe<Scalars['Decimal']>;
};

export type IMutation = {
  __typename?: 'Mutation';
  /** This mutation allow a person to accept an invitation. To be able to verify an account the user must receive an invitation. */
  acceptPersonInvitation?: Maybe<IAcceptPersonInvitationPayload>;
  addColor?: Maybe<IColor>;
  /** Mutation that allows you to add a note to a notable object. It can raise a `NotFoundError` if the notable object is not found. */
  addNote?: Maybe<INote>;
  /**
   * Add an item to an order.
   *
   * **Arguments**
   *
   * | Name        | Type    | Description                               | Required | Default |
   * |-------------|---------|-------------------------------------------|----------|---------|
   * | `order_id`  | ID      | The ID of the order to add the item to    | Yes      |         |
   * | `product_id`| ID      | The ID of the product to add to the order | Yes      |         |
   * | `quantity`  | Integer | The quantity of the product to add        | Yes      |         |
   * | `price`     | Decimal | The price of the product to add           | Yes      | 0.0     |
   *
   * **Returns**
   *
   * An `OrderItem` object if the operation is successful.
   *
   * **Errors**
   *
   * | Name            | Description |
   * |-----------------|-------------|
   * | `NotFoundError` | Returns if the order or product is not found |
   * | `ValidationError` | Returns if the product does not belong to the same brand as the order, is not active, or if the quantity or price is not a positive value. Also returns if the order is in a disallowed status (fulfilled, canceled, shipped, completed) |
   */
  addOrderItem: IOrderItem;
  /** Add a new product */
  addProduct: IProduct;
  addRelationship?: Maybe<IRelationship>;
  addRoleType: IRoleType;
  addSize?: Maybe<ISize>;
  addStyle?: Maybe<IStyle>;
  /** Allocate inventory for an order */
  allocateOrder: IOrder;
  /** Add a line item to an ASN in `RECEIVING` status. This mutation can be used only when the ASN is in the `RECEIVING` status. If called when the ASN is in a status other than `RECEIVING`, an error will be raised. */
  asnAddReceivingItem: IAsnItem;
  /** Allows to cancel an ASN that met the requirements to be canceled */
  asnCancel: IAsn;
  /** This mutation closed the ASN and affects the inventory levels. It can be used only when the ASN is in the `RECEIVING` status. */
  asnClose: IAsn;
  /** This mutation will send the desired ASN(s) to their respective downstream integration.Usable when an ASN is in the 'INCOMING' status. */
  asnSendToWms?: Maybe<IAsnSendToWmsPayload>;
  /**
   * Update a line item that belongs to an ASN in `RECEIVING` status. This mutation is used to update the quantity received, and the verified status of the line item.
   *
   * If called when the ASN is in a status other than `RECEIVING`, an error will be raised.
   *
   * If the line item does not belong to the ASN, an error will be raised.
   *
   * Quantity or verified status must be provided in order to update the line item. If neither is provided, the an error will raised.
   */
  asnUpdateReceivingItem: IAsnItem;
  /**
   * Assigns a role to a company member. After a new role is assigned to a member, the member will inherit the rights an permissions of that role.
   * This mutation will return an error if specified party id is not a member of the company.
   */
  assignRole?: Maybe<IRole>;
  /** This mutation is used to fulfill multiple orders at once. Every order is fulfilled individually, so the performer user should have the permission to fulfill orders in the brand of the order. */
  bulkFulfillOrders?: Maybe<IBulkFulfillOrdersPayload>;
  /** Cancel an order */
  cancelOrder?: Maybe<ICancelOrderPayload>;
  /** Clones a product and duplicates all its data, except for the identifier and the SKU. The new product will be in draft state. */
  cloneProduct?: Maybe<IProduct>;
  /**
   * Completes the forgot password reset process.### Permissions
   * This mutation requires user is not logged, otherwise will fail.
   * ### Successful response
   * If the process was completed successfully a `success` response in `status` field.
   * ### Possible errors
   * In case of error you could receive any of next errors:
   *
   * | Error | Code | Description |
   * | :---- | :----: | :---- |
   * | Email not valid | `GER2006` | The email format is not accepted. |
   */
  completeForgotPassword: ICompleteForgotPasswordPayload;
  /** Create an API ley to enable access for an API client. */
  createApiKey: IApiKey;
  /**
   * Register a new ASN in the system.
   *
   * ## Requirements
   *
   * 1. The user must be authenticated
   * 2. The user must have the `create_asn` permission
   * 3. If the `brand_id` is not provided, the header `X-Brand-Id` must be provided with the brand ID.
   *
   * ## Errors
   *
   *
   */
  createAsn: IAsn;
  createLocation?: Maybe<ILocation>;
  /**
   * Register a new order in the system.
   *
   * ## Requirements
   *
   * 1. The user must be authenticated
   * 2. The user must have the `create_order` permission
   * 3. If the `brand_id` is not provided, the header `X-Brand-Id` must be provided with the brand ID.
   *
   * ## Errors
   *
   *
   */
  createOrder: IOrder;
  /** Create a new sales channel */
  createSalesChannel: ISalesChannel;
  /** Re-links external data to a local object */
  editLinkedExternalData?: Maybe<IEditLinkedExternalDataPayload>;
  /** This action allocated stock to the order and sends it to the external shipping software. */
  fulfillOrder: Array<IOrderFulfillment>;
  /** Queries an external integration to fetch an order's shipments (if any) */
  getExternalShipment?: Maybe<IGetExternalShipmentPayload>;
  /**
   * This action holds the order to prevent it from being fulfilled.
   *
   * This mutation can be performed when the order is in the statuses of 'PENDING', 'ORDERED', or 'ALLOCATED'.
   */
  holdOrder?: Maybe<IHoldOrderPayload>;
  /** Will retroactively import brand carriers if the brand was created without them. */
  importBrandCarriers?: Maybe<IImportBrandCarriersPayload>;
  /**
   * Allow to import an order from an external source like Shopify. The imported order is created as an order in Endless Commerce and processed as a regular order.
   *
   * If the order already exists in Endless Commerce, it will be ignored and the mutation will return an error.
   */
  importExternalOrder?: Maybe<IImportExternalOrderPayload>;
  /** Initiates an inventory transfer. This mutation is used to initiate an inventory transfer. The inventory transfer is a process of moving inventory from one location to another. */
  initInventoryTransfer?: Maybe<IInventoryTransfer>;
  /** Initializes the inventory for a brand. This mutation initialize the inventory for all products in a Brand. The inventory is initialized with a quantity of 0 for all products in the brand and all locations. */
  initializeBrandInventory?: Maybe<IInitializeBrandInventoryPayload>;
  /** Initialize inventory for a product at a location. This mutation should be used when a product is first added to a location, and it can be used only once for every product that is wanted to be initialized in the inventory. If the product is already initialized, this mutation will return an error. */
  initializeInventory: IInventoryItem;
  /** Perform manual inventory adjustment. This mutation affects the total quantity available in the specified locations.  */
  inventoryQuickAdjust?: Maybe<IInventoryItem>;
  /** This mutation registers a new person with a user account. After the person is registered, an invitation email is sent to the person. */
  invitePerson?: Maybe<IParty>;
  /** Links external data to a local object. */
  linkExternalData?: Maybe<ILinkExternalDataPayload>;
  magicSignIn?: Maybe<IMagicSignInPayload>;
  /** This mutation allow to mark the ASN as arrived. */
  markAsnAsArrived: IAsn;
  onboardBrand: IBrand;
  orderOperations?: Maybe<IOrderOperationsPayload>;
  registerApiClient: IApiClient;
  /**
   * Register a new carrier for a brand. This mutation allows you to register a new carrier for a specific brand. The brand can be specified by the `brand_id` argument. If `brand_id` is not provided, the brand will be determined by the `X-Brand-Id` header.
   *
   * ### Arguments
   * | Name | Type | Description |
   * | ---- | ---- | ----------- |
   * | name | String | The name of the carrier. This is a required argument. |
   * | description | String | The description of the carrier. This is an optional argument. |
   * | category | CarrierCategoryEnum | The category of the carrier. This is an optional argument with a default value of `:standard`. |
   * | status | StatusEnum | The status of the carrier. This is an optional argument with a default value of `'ACTIVE'`. |
   * | brand_id | ID | The brand ID to register the carrier for. If not provided, will use the brand provided in the `X-Brand-Id` header. This is an optional argument. |
   * | global | Boolean | Whether the carrier is global. This is an optional argument with a default value of `false`. |
   *
   *
   * ### Errors
   * This mutation may return the following errors:
   * - `NotFoundError`: If the provided `brand_id` is not a valid brand ID.
   *
   *
   * ### Return Value
   * This mutation returns a `CarrierType` object representing the newly registered carrier.
   */
  registerCarrier?: Maybe<ICarrier>;
  /** Add a new mapping between an external carrier and a carrier in our system. */
  registerCarrierMapping?: Maybe<ICarrierMapping>;
  /**
   * Registers a new carrier service.
   *
   * ## Arguments:
   * | Name | Type | Required | Description |
   * |------|------|----------|-------------|
   * | `carrier_id` | ID | Yes | ID of the carrier |
   * | `name` | String | Yes | Name of the carrier service |
   * | `description` | String | No | Description of the carrier service |
   * | `status` | StatusEnum | No | Status of the carrier service (default is `ACTIVE`) |
   *
   * Returns the newly created carrier service.
   *
   * ## Possible errors:
   * | Error | Description |
   * |-------|-------------|
   * | `NotFoundError` | If the carrier is not found |
   * | `ValidationError` | If the service name length is less than 3 characters |
   * | `ValidationError` | If the service already exists for the carrier |
   * | `ValidationError` | If the carrier does not belong to the brand |
   *
   * Return type: `Types::Base::CarrierServiceType`
   */
  registerCarrierService: ICarrierService;
  registerCarrierServiceMapping?: Maybe<ICarrierServiceMapping>;
  /** Register a new Company. Companies are the elements that allow to manage users and Brands. Once the company is created you'll be able to add Brand's and users. */
  registerCompany: IParty;
  /**
   * Add a new product category. The category will be added to the current brand.
   *
   * The actor should have the `add_product_category` permission.
   *
   * ### Headers:
   *
   * | Header | Value | Required |
   * | ------ | ----- | -------- |
   * | Authorization | `Bearer [token]` | Yes |
   * | X-Brand-Id | `[brand-id]` | Yes |
   */
  registerProductCategory?: Maybe<IProductCategory>;
  /** Register a new warehouse. Warehouses belong to a company. */
  registerWarehouse?: Maybe<IWarehouse>;
  /** This action releases the order to allow it to be processed. */
  releaseOrder?: Maybe<IReleaseOrderPayload>;
  /** Remove an integration from a brand. */
  removeIntegration?: Maybe<IRemoveIntegrationPayload>;
  /** Mutation that allows you to remove a note from a notable object. It can raise a `NotFoundError` if the note is not found. */
  removeNote: INote;
  /**
   * Remove an item from an order. This mutation allows you to remove an existing order item. You need to provide the ID of the order item you want to remove. The mutation will return the status of the operation and the name of the removed item. If the order item with the provided ID does not exist, it will raise an 'Order item not found' error.
   *
   * Parameters:
   *
   * | Name | Type | Description |
   * | ---- | ---- | ----------- |
   * | id | ID | ID of the order item to remove |
   *
   * Errors:
   *
   * | Error | Description |
   * | ----- | ----------- |
   * | Order item not found | The order item with the provided ID does not exist |
   *
   * Returns:
   *
   * | Name | Type | Description |
   * | ---- | ---- | ----------- |
   * | status | StatusResultEnum | Status of the operation |
   * | removed_item | String | The name of the removed item |
   */
  removeOrderItem?: Maybe<IRemoveOrderItemPayload>;
  /** Remove a relationship between two parties. */
  removeRelationship?: Maybe<IDeletedResponse>;
  /** This action triggers the order unfulfillment process that will set the order status from a fulfilled or `IN_PROGRESS` status to an on `ORDERED` status. */
  requestOrderUnfulfillment?: Maybe<IRequestOrderUnfulfillmentPayload>;
  /**
   * Rotate the session token for the current user. This mutation allows you to generate a new session token, which can be used to extend the user's session. The new token, its expiration date, and the number of seconds left until it expires are returned in the response, and the old token is invalidated.
   *
   * ## Arguments
   * | Name | Type | Description |
   * | ---- | ---- | ----------- |
   * | `input` | `EmptyInputType` | An empty hash. |
   *
   *
   * ## Fields
   * | Name | Type | Description |
   * | ---- | ---- | ----------- |
   * | `token` | `String` | The new session token. |
   * | `valid_until` | `ISO8601DateTime` | The expiration date of the new token. |
   * | `seconds_left` | `Integer` | The number of seconds left until the new token expires. |
   *
   *
   * This mutation requires the user to be authenticated.
   */
  rotateSessionToken?: Maybe<IRotateSessionTokenPayload>;
  runIntegrationAction?: Maybe<IRunIntegrationActionPayload>;
  sendMagicLink?: Maybe<ISendMagicLinkPayload>;
  /** Set the default sales channel for a Brand */
  setDefaultSalesChannel?: Maybe<ISetDefaultSalesChannelPayload>;
  /**
   * Setup an integration and assign it to a brand. This mutation requires to include the company context.
   *
   * Mutation details:
   *
   * * Header `X-Company-Id` must be provided.
   * * Header `Authorization` must be provided.
   * * If the header `X-Brand-Id` id provided then the argument `brandId` is optional, otherwise it is required.
   *
   */
  setupIntegration: IIntegration;
  /** Ship an order manually without send it to an external system. */
  shipOrderManually?: Maybe<IOrder>;
  /** Creates a new session for an already registered user. Once you get the token, use it in the request header as `Bearer Token` to access the available resources. */
  signIn?: Maybe<ISignInPayload>;
  /** Sign out the current user. */
  signOut?: Maybe<ISignOutPayload>;
  /**
   * Mutation to create a user account.
   * ### Possible errors
   * In case of error you could receive any of the following errors:
   */
  signUp?: Maybe<ISignUpPayload>;
  /** This mutation transitions an ASN from the 'ARRIVED' status to the `RECEIVING` status, allowing users to begin verifying received items and quantities */
  startAsnReceiving: IAsn;
  /**
   * Starts the forgot password reset process.### Permissions
   * This mutation requires user is not logged, otherwise will fail.
   * ### Successful response
   * If the process was completed successfully a `success` response in `status` field.
   */
  startForgotPassword: IStartForgotPasswordPayload;
  /** This mutation will request an inventory update for the desired ASN(s) from therespective downstream integration. */
  syncAsnInventory?: Maybe<ISyncAsnInventoryPayload>;
  /** Sync inventory with an external source. The operation is unidirectional from Endless Commerce */
  syncInventory?: Maybe<ISyncInventoryPayload>;
  /** Sync specific products with an external source. The operation works in both ways, it can be used to sync products from the external source to the local database or vice versa. This operation can be used to sync products with a specific integration or all integrations and the synchronization is performed asynchronously. */
  syncProducts?: Maybe<ISyncProductsPayload>;
  /** Remove a role from a user. The role can be removed from the system, from a company or from a brand. This mutation is only available for admins of the affected context. */
  unassignRole: IStatusResponse;
  /** This action sets an order status from a fulfilled or in progress status to an on ordered status.If the order is not in the correct status, it will throw an error.If the order is being fulfilled via an external integration, the order in the external integration will be canceled. */
  unfulfillOrder: IOrder;
  /**
   * Unship an order. This mutation unships an order, setting the order's status to 'ALLOCATED'. The order must have a status of 'SHIPPED' in order to be unshipped. If the order is not in the 'SHIPPED' status, this mutation will return an error.
   *
   * Additionally, if the order is present in external systems, this mutation will attempt to unship the order in those systems as well.
   */
  unshipOrder?: Maybe<IUnshipOrderPayload>;
  /** Update the basic details of an API client. */
  updateApiClient: IApiClient;
  /** Update an existing API key */
  updateApiKey: IApiKey;
  /** Update an existing ASN in the system. Only provided arguments will be updated. */
  updateAsn: IAsn;
  /** Allow to update a brand. Requires authentication. */
  updateBrand: IBrand;
  /**
   * Updates a specific external integration assigned to a brand. This mutation requires to include the company context.
   *
   * Mutation details:
   *
   * * Header `X-Company-Id` must be provided.
   * * Header `Authorization` must be provided.
   * * If the header `X-Brand-Id` id provided then the argument `brandId` is optional, otherwise it is required.
   */
  updateIntegration?: Maybe<IParty>;
  /** Update the current party profile. This mutation will affect the current logged in party's profile. */
  updateMyProfile: IParty;
  /** This action allows the user to update a single order if the order is in the draft or ordered status.If the order is not in the correct status, it will throw an error. */
  updateOrder: IOrder;
  /**
   * Update an order item. This mutation allows you to update the quantity and price of an existing order item. You need to provide the ID of the order item you want to update. The quantity and price are optional parameters. If they are not provided, the existing values will be kept. The mutation will return the updated order item. If the order item with the provided ID does not exist, it will raise an 'Order item not found' error.
   *
   * Parameters:
   *
   * | Name | Type | Description |
   * | ---- | ---- | ----------- |
   * | id | ID | ID of the order item to update |
   * | quantity | Int | New quantity of the order item |
   * | price | Decimal | New price of the order item |
   *
   * Errors:
   *
   * | Error | Description |
   * | ----- | ----------- |
   * | Order item not found | The order item with the provided ID does not exist |
   *
   * Returns:
   *
   * The updated order item.
   */
  updateOrderItem: IOrderItem;
  /** Update a product by ID. This mutation will update only the fields that are provided. */
  updateProduct: IProduct;
  /** Update a sales channel */
  updateSalesChannel: ISalesChannel;
  /** Update an existing warehouse. */
  updateWarehouse?: Maybe<IWarehouse>;
  /**
   * This is used to verify a login identifier. This mutation should be used after the system has sent a verification email or message to the user. The user should have clicked on the link or entered the code sent to them.
   *
   * ### Possible errors
   * In case of error you could receive any of the following errors:
   * - `ErrorTokenNotValid` when the token is not valid.
   * - `AlreadyLoggedIn` when the user is already logged in.
   */
  verifyAccount?: Maybe<IVerifyAccountPayload>;
};


export type IMutationAcceptPersonInvitationArgs = {
  input: IAcceptPersonInvitationInput;
};


export type IMutationAddColorArgs = {
  input: IAddColorInput;
};


export type IMutationAddNoteArgs = {
  input: IAddNoteInput;
};


export type IMutationAddOrderItemArgs = {
  input: IAddOrderItemInput;
};


export type IMutationAddProductArgs = {
  input: IAddProductInput;
};


export type IMutationAddRelationshipArgs = {
  input: IAddRelationshipInput;
};


export type IMutationAddRoleTypeArgs = {
  input: IAddRoleInput;
};


export type IMutationAddSizeArgs = {
  input: IAddSizeInput;
};


export type IMutationAddStyleArgs = {
  input: IAddStyleInput;
};


export type IMutationAllocateOrderArgs = {
  input: IAllocateOrderInput;
};


export type IMutationAsnAddReceivingItemArgs = {
  input: IAsnAddReceivingItemInput;
};


export type IMutationAsnCancelArgs = {
  input: IAsnCancelInput;
};


export type IMutationAsnCloseArgs = {
  input: IAsnCloseInput;
};


export type IMutationAsnSendToWmsArgs = {
  input: IAsnSendToWmsInput;
};


export type IMutationAsnUpdateReceivingItemArgs = {
  input: IAsnUpdateReceivingItemInput;
};


export type IMutationAssignRoleArgs = {
  input: IAssignRoleInput;
};


export type IMutationBulkFulfillOrdersArgs = {
  input: IBulkFulfillOrdersInput;
};


export type IMutationCancelOrderArgs = {
  input: ICancelOrderInput;
};


export type IMutationCloneProductArgs = {
  input: ICloneProductInput;
};


export type IMutationCompleteForgotPasswordArgs = {
  input: ICompleteForgotPasswordInput;
};


export type IMutationCreateApiKeyArgs = {
  input: ICreateApiKeyInput;
};


export type IMutationCreateAsnArgs = {
  input: ICreateAsnInput;
};


export type IMutationCreateLocationArgs = {
  input: ICreateLocationInput;
};


export type IMutationCreateOrderArgs = {
  input: ICreateOrderInput;
};


export type IMutationCreateSalesChannelArgs = {
  input: ICreateSalesChannelInput;
};


export type IMutationEditLinkedExternalDataArgs = {
  input: IEditLinkedExternalDataInput;
};


export type IMutationFulfillOrderArgs = {
  input: IFulfillOrderInput;
};


export type IMutationGetExternalShipmentArgs = {
  input: IGetExternalShipmentInput;
};


export type IMutationHoldOrderArgs = {
  input: IHoldOrderInput;
};


export type IMutationImportBrandCarriersArgs = {
  input: IImportBrandCarriersInput;
};


export type IMutationImportExternalOrderArgs = {
  input: IImportExternalOrderInput;
};


export type IMutationInitInventoryTransferArgs = {
  input: IInitInventoryTransferInput;
};


export type IMutationInitializeBrandInventoryArgs = {
  input: IInitializeBrandInventoryInput;
};


export type IMutationInitializeInventoryArgs = {
  input: IInitializeInventoryInput;
};


export type IMutationInventoryQuickAdjustArgs = {
  input: IInventoryQuickAdjustInput;
};


export type IMutationInvitePersonArgs = {
  input: IInvitePersonInput;
};


export type IMutationLinkExternalDataArgs = {
  input: ILinkExternalDataInput;
};


export type IMutationMagicSignInArgs = {
  input: IMagicSignInInput;
};


export type IMutationMarkAsnAsArrivedArgs = {
  input: IMarkAsnAsArrivedInput;
};


export type IMutationOnboardBrandArgs = {
  input: IOnboardBrandInput;
};


export type IMutationOrderOperationsArgs = {
  input: IOrderOperationsInput;
};


export type IMutationRegisterApiClientArgs = {
  input: IRegisterApiClientInput;
};


export type IMutationRegisterCarrierArgs = {
  input: IRegisterCarrierInput;
};


export type IMutationRegisterCarrierMappingArgs = {
  input: IRegisterCarrierMappingInput;
};


export type IMutationRegisterCarrierServiceArgs = {
  input: IRegisterCarrierServiceInput;
};


export type IMutationRegisterCarrierServiceMappingArgs = {
  input: IRegisterCarrierServiceMappingInput;
};


export type IMutationRegisterCompanyArgs = {
  input: IRegisterCompanyInput;
};


export type IMutationRegisterProductCategoryArgs = {
  input: IRegisterProductCategoryInput;
};


export type IMutationRegisterWarehouseArgs = {
  input: IRegisterWarehouseInput;
};


export type IMutationReleaseOrderArgs = {
  input: IReleaseOrderInput;
};


export type IMutationRemoveIntegrationArgs = {
  input: IRemoveIntegrationInput;
};


export type IMutationRemoveNoteArgs = {
  input: IRemoveNoteInput;
};


export type IMutationRemoveOrderItemArgs = {
  input: IRemoveOrderItemInput;
};


export type IMutationRemoveRelationshipArgs = {
  input: IRemoveRelationshipInput;
};


export type IMutationRequestOrderUnfulfillmentArgs = {
  input: IRequestOrderUnfulfillmentInput;
};


export type IMutationRotateSessionTokenArgs = {
  input: IRotateSessionTokenInput;
};


export type IMutationRunIntegrationActionArgs = {
  input: IRunIntegrationActionInput;
};


export type IMutationSendMagicLinkArgs = {
  input: ISendMagicLinkInput;
};


export type IMutationSetDefaultSalesChannelArgs = {
  input: ISetDefaultSalesChannelInput;
};


export type IMutationSetupIntegrationArgs = {
  input: ISetupIntegrationInput;
};


export type IMutationShipOrderManuallyArgs = {
  input: IShipOrderManuallyInput;
};


export type IMutationSignInArgs = {
  input: ISignInInput;
};


export type IMutationSignOutArgs = {
  input: ISignOutInput;
};


export type IMutationSignUpArgs = {
  input: ISignUpInput;
};


export type IMutationStartAsnReceivingArgs = {
  input: IStartAsnReceivingInput;
};


export type IMutationStartForgotPasswordArgs = {
  input: IStartForgotPasswordInput;
};


export type IMutationSyncAsnInventoryArgs = {
  input: ISyncAsnInventoryInput;
};


export type IMutationSyncInventoryArgs = {
  input: ISyncInventoryInput;
};


export type IMutationSyncProductsArgs = {
  input: ISyncProductsInput;
};


export type IMutationUnassignRoleArgs = {
  input: IUnassignRoleInput;
};


export type IMutationUnfulfillOrderArgs = {
  input: IUnfulfillOrderInput;
};


export type IMutationUnshipOrderArgs = {
  input: IUnshipOrderInput;
};


export type IMutationUpdateApiClientArgs = {
  input: IUpdateApiClientInput;
};


export type IMutationUpdateApiKeyArgs = {
  input: IUpdateApiKeyInput;
};


export type IMutationUpdateAsnArgs = {
  input: IUpdateAsnInput;
};


export type IMutationUpdateBrandArgs = {
  input: IUpdateBrandInput;
};


export type IMutationUpdateIntegrationArgs = {
  input: IUpdateIntegrationInput;
};


export type IMutationUpdateMyProfileArgs = {
  input: IUpdateMyProfileInput;
};


export type IMutationUpdateOrderArgs = {
  input: IUpdateOrderInput;
};


export type IMutationUpdateOrderItemArgs = {
  input: IUpdateOrderItemInput;
};


export type IMutationUpdateProductArgs = {
  input: IUpdateProductInput;
};


export type IMutationUpdateSalesChannelArgs = {
  input: IUpdateSalesChannelInput;
};


export type IMutationUpdateWarehouseArgs = {
  input: IUpdateWarehouseInput;
};


export type IMutationVerifyAccountArgs = {
  input: IVerifyAccountInput;
};

/** The status of the order. */
export enum INewOrderStatusEnum {
  /** The order is in draft status. */
  Draft = 'DRAFT',
  /** The order is in ordered status. */
  Ordered = 'ORDERED'
}

export type INotable = IAsn | IInventoryItem | IOrder | IProduct;

export enum INotableObjectEnum {
  /** ASN */
  Asn = 'ASN',
  /** Order */
  InventoryItem = 'INVENTORY_ITEM',
  /** Order */
  Order = 'ORDER',
  /** Order */
  Product = 'PRODUCT'
}

/** The `NoteType` is a GraphQL object type that represents a note in the system. */
export type INote = {
  __typename?: 'Note';
  /** The party associated with the note. */
  author?: Maybe<IParty>;
  /** The ID of the party associated with the note. */
  authorId?: Maybe<Scalars['ID']>;
  /** The content of the note. */
  content: Scalars['String'];
  /** The date and time when the note was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The date and time when the note was deleted. */
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The unique identifier of the note. */
  id: Scalars['ID'];
  /** The object that the note is attached to. */
  notable: INotable;
  /** The ID of the object that the note is attached to. */
  notableId: Scalars['ID'];
  /** The type of the object that the note is attached to. */
  notableType: INotableObjectEnum;
  /** The type of the note. */
  noteType?: Maybe<INoteTypeEnum>;
  /** The date and time when the note was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for Note. */
export type INoteConnection = {
  __typename?: 'NoteConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<INoteEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<INote>>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** Total count of items in the connection, without considering pagination. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type INoteEdge = {
  __typename?: 'NoteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<INote>;
};

/**
 * The `NoteFilterInput` object is used to filter the results of the Notes query. Each field corresponds to a specific attribute in the notes and is optional. If a field is provided, the query will return only the notes that match the provided value for that field.
 *
 * | Field | Type | Description |
 * | --- | --- | --- |
 * | `keyword` | String | Keyword to filter the notes by. |
 * | `author_id` | ID | ID of the author of the note. |
 * | `start_date` | DateTime | Start date for filtering the notes. Only notes created after this date will be returned. |
 * | `end_date` | DateTime | End date for filtering the notes. Only notes created before this date will be returned. |
 * | `sort_type` | Enum | Sort type for the notes. |
 * | `sort_field` | Enum | Field to sort the notes by. |
 */
export type INoteFiltersInput = {
  /** Filter by author. This field corresponds to the author of the note. */
  authorId?: InputMaybe<Scalars['ID']>;
  /** Filter by `end_date`. This field is used to filter the notes by the date and time they were created. Only notes created before the `end_date` will be returned. */
  endDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Filter by keyword. This field is used to filter the notes by the content of the note. */
  keyword?: InputMaybe<Scalars['String']>;
  /** Sort type for the notes. */
  sortType?: InputMaybe<ISortTypeEnum>;
  /** Filter by `start_date`. This field is used to filter the notes by the date and time they were created. Only notes created after the `start_date` will be returned. */
  startDate?: InputMaybe<Scalars['ISO8601DateTime']>;
};

/** A note input object. Notes can be used by different entities in the system. For example, a note can be used in an order, a product, a warehouse, etc. */
export type INoteInput = {
  /** The note content. */
  note: Scalars['String'];
};

/** The type of the note. */
export enum INoteTypeEnum {
  /** A note provided by a user. */
  Custom = 'CUSTOM',
  /** A note generated by an integration. */
  Integration = 'INTEGRATION',
  /** A note generated by the system. */
  System = 'SYSTEM'
}

/** Autogenerated input type of OnboardBrand */
export type IOnboardBrandInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Party ID of the company that will own the brand.  */
  companyId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['Url']>;
  name: Scalars['String'];
  /** Party ID of the person that will be responsible of the brand. This person will be the default contact for the brand and also will be assigned as the admin of the brand. */
  responsibleId: Scalars['ID'];
  status?: InputMaybe<IBrandStatusEnum>;
  /** ID of the warehouse that will be associated with the brand. This warehouse will be used as the default warehouse for the brand. */
  warehouseId?: InputMaybe<Scalars['ID']>;
  websiteUrl?: InputMaybe<Scalars['Url']>;
};

/** The order type. This type represents an order in the system. */
export type IOrder = {
  __typename?: 'Order';
  billToCompany?: Maybe<Scalars['String']>;
  billToEmail?: Maybe<Scalars['Email']>;
  billToName?: Maybe<Scalars['String']>;
  billToPhone?: Maybe<Scalars['PhoneNumber']>;
  billingAddress?: Maybe<IAddress>;
  /** The brand object of the order. User must have the `read_brand` permission. */
  brand: IBrand;
  brandId: Scalars['ID'];
  createdAt: Scalars['ISO8601DateTime'];
  /** The party that created the order. */
  createdBy: IParty;
  createdById: Scalars['ID'];
  deliveredDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** The estimated weight of the order. This value is calculated based on the weight of the products. */
  estimatedWeight: Scalars['Decimal'];
  expectedDeliveryDate?: Maybe<Scalars['ISO8601DateTime']>;
  expectedShipDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** The financial information of the order. */
  financial: IOrderFinancial;
  /** The financial status of the order. */
  financialStatus: IOrderFinancialStatusEnum;
  /** The date when the first item of the order was shipped. */
  firstShipDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** The fulfillment method of the order. LOCAL means the order is fulfilled by Endless Commerce. PARTIALLY_PROCESSABLE means some items are fulfilled by Endless Commerce and some are fulfilled by a third party. NON_PROCESSABLE means the order is fulfilled by a third party. */
  fulfillmentMethod: IOrderFulfillmentMethodEnum;
  /** The fulfillments of the order. An order can have zero or more fulfillments. */
  fulfillments: Array<IOrderFulfillment>;
  id: Scalars['ID'];
  /** The auto-generated internal order number. This number is used for internal purposes and is unique per order. */
  internalOrderNumber: Scalars['String'];
  /** The metadata that is part of the order. */
  metadata?: Maybe<Scalars['JSON']>;
  /** The notes that are part of the order. */
  notes: Array<INote>;
  /** The errors that are part of the order. This field is only available when through the `order` query and will return `null` when no errors are present or when called through other queries. */
  orderErrors?: Maybe<Array<IOrderError>>;
  /** The products that are part of the order. */
  orderItems: Array<IOrderItem>;
  orderNumber: Scalars['String'];
  /** The name of the external system where the order originated. */
  origin?: Maybe<IOrderOriginEnum>;
  /** The order ID from the external system. */
  originOrderId?: Maybe<Scalars['String']>;
  /** The URL of the order in the external system if available. */
  originUrl?: Maybe<Scalars['Url']>;
  /** The previous status object of the order. */
  previousStatus?: Maybe<IOrderStatus>;
  /** The person that is responsible for the order. */
  responsible?: Maybe<IPerson>;
  responsibleId?: Maybe<Scalars['ID']>;
  /** The sales channel object of the order. User must have the `read_sales_channel` permission. */
  salesChannel: ISalesChannel;
  salesChannelId: Scalars['ID'];
  /** @deprecated Deprecated in favor of `shippingCarrierService`. */
  selectedCarrier?: Maybe<ICarrier>;
  /** @deprecated Deprecated in favor of `shippingCarrierService`. */
  selectedCarrierId?: Maybe<Scalars['ID']>;
  /** @deprecated Deprecated in favor of `shippingCarrierService`. */
  selectedCarrierService?: Maybe<ICarrierService>;
  /** @deprecated Deprecated in favor of `shippingCarrierService`. */
  selectedCarrierServiceId?: Maybe<Scalars['ID']>;
  shipToCompany?: Maybe<Scalars['String']>;
  shipToEmail?: Maybe<Scalars['Email']>;
  shipToName?: Maybe<Scalars['String']>;
  shipToPhone?: Maybe<Scalars['PhoneNumber']>;
  /** Indicates if the **Ship To** information is the same as the **Bill To** information. */
  shipToSameAsBillTo: Scalars['Boolean'];
  /** The shipments of the order. An order can have zero or more shipments. */
  shipments: Array<IOrderShipmentUnion>;
  /** @deprecated User `firstShipDate instead`. */
  shippedDate?: Maybe<Scalars['ISO8601DateTime']>;
  shippingAddress?: Maybe<IAddress>;
  shippingCarrierService?: Maybe<Scalars['String']>;
  shippingCost?: Maybe<Scalars['Decimal']>;
  /** The statistics of the order. */
  stats: IOrderStats;
  /** The status object of the order. */
  status: IOrderStatus;
  /** The alerts associated with the status. */
  statusAlerts: Array<IOrderStatusAlert>;
  /** The code name of the order status. */
  statusName: IOrderStatusEnum;
  /** The tags assigned to the order. Tags in the order are used to enable processing functionality and to categorize orders. */
  tags: Array<IOrderTag>;
  /** Indicates if the order shipping is billed to a third party. */
  thirdPartyBilling: Scalars['Boolean'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for Order. */
export type IOrderConnection = {
  __typename?: 'OrderConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IOrderEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IOrder>>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** Total count of items in the connection, without considering pagination. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type IOrderEdge = {
  __typename?: 'OrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<IOrder>;
};

export type IOrderError = {
  __typename?: 'OrderError';
  /** The field that has the error */
  field: Scalars['String'];
  /** The reason for the error */
  reason: Scalars['String'];
};

/** This type represents an external order shipment. An order can have multiple shipments, each one associated with a carrier that shipped the order */
export type IOrderExternalShipment = {
  __typename?: 'OrderExternalShipment';
  account?: Maybe<Scalars['String']>;
  carrier: ICarrier;
  carrierId: Scalars['ID'];
  carrierService: ICarrierService;
  carrierServiceId: Scalars['ID'];
  /** The number of cartons in the shipment */
  cartons?: Maybe<Scalars['Int']>;
  cost?: Maybe<Scalars['Decimal']>;
  createdAt: Scalars['ISO8601DateTime'];
  deliveredDate?: Maybe<Scalars['ISO8601DateTime']>;
  expectedDeliveryDate?: Maybe<Scalars['ISO8601DateTime']>;
  height?: Maybe<Scalars['Decimal']>;
  id: Scalars['ID'];
  length?: Maybe<Scalars['Decimal']>;
  orderId: Scalars['ID'];
  packageType: IPackageTypeEnum;
  /** The number of pallets in the shipment */
  pallets?: Maybe<Scalars['Int']>;
  shippedDate: Scalars['ISO8601DateTime'];
  status: Scalars['String'];
  trackingNumber: Scalars['String'];
  trackingUrl?: Maybe<Scalars['Url']>;
  updatedAt: Scalars['ISO8601DateTime'];
  weight?: Maybe<Scalars['Decimal']>;
  width?: Maybe<Scalars['Decimal']>;
};

/** Represents a filtering option for orders. */
export type IOrderFilter = {
  __typename?: 'OrderFilter';
  brands?: Maybe<Array<IFilterOption>>;
  carriers?: Maybe<Array<IFilterOption>>;
  /** Sales channel IDs to filter orders by. */
  salesChannels?: Maybe<Array<IFilterOption>>;
  services?: Maybe<Array<IFilterOption>>;
  statuses?: Maybe<Array<IFilterOption>>;
};

/** Filtering options for orders */
export type IOrderFilterInput = {
  brandIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Carrier IDs to filter orders by. */
  carrierIds?: InputMaybe<Array<Scalars['ID']>>;
  createdById?: InputMaybe<Scalars['ID']>;
  /** End date to filter orders by. */
  endDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Fulfillability status to filter orders by. If not provided, all fulfillable statuses will be included. */
  fulfillable?: InputMaybe<Scalars['Boolean']>;
  /** Fulfillment methods to filter orders by. */
  fulfillmentMethods?: InputMaybe<Array<IOrderFulfillmentMethodEnum>>;
  /** Keyword to search for in orders. This keyword will be searched in order number, ship to name, ship to email, ship to phone, ship to company, bill to name, bill to email, bill to phone, and bill to company. */
  keyword?: InputMaybe<Scalars['String']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  responsibleId?: InputMaybe<Scalars['ID']>;
  /** Sales channel IDs to filter orders by. */
  salesChannelIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Field to sort orders by. */
  sortField?: InputMaybe<IOrderSortFieldEnum>;
  /** Sort type for orders. */
  sortType?: InputMaybe<ISortTypeEnum>;
  /** Start date to filter orders by. */
  startDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  status?: InputMaybe<Array<IOrderStatusEnum>>;
};

export type IOrderFinancial = {
  __typename?: 'OrderFinancial';
  /** The amount of shipping charged to the customer. */
  customerShipping?: Maybe<Scalars['Decimal']>;
  /** The amount of discount applied to the order. */
  discount?: Maybe<Scalars['Decimal']>;
  /** The actual amount of shipping charged by the fulfillment provider. */
  shipping: Scalars['Decimal'];
  /** The subtotal amount of the order. */
  subtotal: Scalars['Decimal'];
  /** The amount of taxes paid. */
  taxes: Scalars['Decimal'];
  /** The total amount of the order. */
  total: Scalars['Decimal'];
};

export enum IOrderFinancialStatusEnum {
  /** Authorized */
  Authorized = 'AUTHORIZED',
  /** Paid */
  Paid = 'PAID',
  /** Partially Paid */
  PartiallyPaid = 'PARTIALLY_PAID',
  /** Partially Refunded */
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  /** Pending */
  Pending = 'PENDING',
  /** Refunded */
  Refunded = 'REFUNDED',
  /** Voided */
  Voided = 'VOIDED'
}

/** This type represents an order fulfillment. An order can have multiple fulfillments, each one associated with a warehouse and a party that fulfilled the order. */
export type IOrderFulfillment = {
  __typename?: 'OrderFulfillment';
  createdAt: Scalars['ISO8601DateTime'];
  externalId?: Maybe<Scalars['String']>;
  fulfilledBy: IParty;
  fulfilledById: Scalars['ID'];
  fulfillmentIntegration?: Maybe<IIntegration>;
  fulfillmentIntegrationId?: Maybe<Scalars['ID']>;
  fulfillmentItems?: Maybe<Array<IFulfillmentItem>>;
  fulfillmentOrderNumber?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  order: IOrder;
  orderId: Scalars['ID'];
  shipments?: Maybe<Array<IOrderShipment>>;
  updatedAt: Scalars['ISO8601DateTime'];
  warehouse: IWarehouse;
  warehouseId: Scalars['ID'];
};

export enum IOrderFulfillmentMethodEnum {
  /** Local Order */
  Local = 'LOCAL',
  /** Non Processable Order */
  NonProcessable = 'NON_PROCESSABLE',
  /** Partially Processable Order */
  PartiallyProcessable = 'PARTIALLY_PROCESSABLE'
}

/** The order item type. This type represents an order item in the system. */
export type IOrderItem = {
  __typename?: 'OrderItem';
  /** The allocation info for the order item. This information includes information about the location where the item is allocated, the quantity allocated, and the status of the allocation. */
  allocationInfo?: Maybe<Array<IItemAllocation>>;
  createdAt: Scalars['ISO8601DateTime'];
  discount?: Maybe<Scalars['Decimal']>;
  id: Scalars['ID'];
  /** The inventory item object of the order item. User must have the `read_inventory_item` permission. */
  inventoryItem?: Maybe<IInventoryItem>;
  price?: Maybe<Scalars['Float']>;
  processable: Scalars['Boolean'];
  /** The product object of the order item. User must have the `read_product` permission. */
  product?: Maybe<IProduct>;
  productId: Scalars['ID'];
  quantity: Scalars['Int'];
  total?: Maybe<Scalars['Decimal']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Filtering options for orders items */
export type IOrderItemFilterInput = {
  /** Keyword to search for in order items. Searches in product name and SKU. */
  keyword?: InputMaybe<Scalars['String']>;
  /** Field to sort order items by. */
  sortField?: InputMaybe<IOrderItemSortFieldsEnum>;
  /** Sort type for order items. */
  sortType?: InputMaybe<ISortTypeEnum>;
};

/** The input object for an order item. */
export type IOrderItemInput = {
  /** If this is set to true, the system will delete the order item. If this is provided, the `id` field must be provided as well and other fields will be ignored. */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** The order item ID. If this is provided, the system will update the existing order item. If this is not provided, the system will create a new order item. */
  id?: InputMaybe<Scalars['ID']>;
  /** The price of the product. */
  price?: InputMaybe<Scalars['Decimal']>;
  /** The product ID. */
  productId?: InputMaybe<Scalars['ID']>;
  /** The quantity of the product. */
  quantity?: InputMaybe<Scalars['Int']>;
  /** The product SKU. */
  sku?: InputMaybe<Scalars['String']>;
};

/** Fields to sort order items by */
export enum IOrderItemSortFieldsEnum {
  /** Sort by created at date */
  CreatedDate = 'CREATED_DATE',
  /** Sort by price */
  Name = 'NAME',
  /** Sort by price */
  Price = 'PRICE',
  /** Sort by quantity */
  Quantity = 'QUANTITY',
  /** Sort by updated at date */
  UpdatedDate = 'UPDATED_DATE'
}

/** Autogenerated input type of OrderOperations */
export type IOrderOperationsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  operation: Scalars['String'];
  operationData?: InputMaybe<Scalars['JSON']>;
  orderId: Scalars['ID'];
};

/** Autogenerated return type of OrderOperations. */
export type IOrderOperationsPayload = {
  __typename?: 'OrderOperationsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['ID']>;
  result: IStatusResultEnum;
};

/** Possible origins of an order. */
export enum IOrderOriginEnum {
  /** Local Order */
  Local = 'LOCAL',
  /** Shopify */
  Shopify = 'SHOPIFY'
}

/** This type represents an order shipment. An order can have multiple shipments, each one associated with a fulfillment and a carrier that shipped the order */
export type IOrderShipment = {
  __typename?: 'OrderShipment';
  account?: Maybe<Scalars['String']>;
  /** @deprecated Outdated method for carriers */
  carrier?: Maybe<ICarrier>;
  carrierId?: Maybe<Scalars['ID']>;
  /** @deprecated Outdated method for carriers */
  carrierService?: Maybe<ICarrierService>;
  /** @deprecated Outdated method for carriers */
  carrierServiceId?: Maybe<Scalars['ID']>;
  /** The number of cartons in the shipment */
  cartons?: Maybe<Scalars['Int']>;
  cost?: Maybe<Scalars['Decimal']>;
  createdAt: Scalars['ISO8601DateTime'];
  deliveredDate?: Maybe<Scalars['ISO8601DateTime']>;
  expectedDeliveryDate?: Maybe<Scalars['ISO8601DateTime']>;
  fulfillment?: Maybe<IOrderFulfillment>;
  fulfillmentId?: Maybe<Scalars['ID']>;
  height?: Maybe<Scalars['Decimal']>;
  id: Scalars['ID'];
  length?: Maybe<Scalars['Decimal']>;
  packageType: IPackageTypeEnum;
  /** The number of pallets in the shipment */
  pallets?: Maybe<Scalars['Int']>;
  shippedDate: Scalars['ISO8601DateTime'];
  shippingCarrierService?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  trackingNumber: Scalars['String'];
  trackingUrl?: Maybe<Scalars['Url']>;
  updatedAt: Scalars['ISO8601DateTime'];
  weight?: Maybe<Scalars['Decimal']>;
  width?: Maybe<Scalars['Decimal']>;
};

/** A shipment of an order */
export type IOrderShipmentUnion = IOrderExternalShipment | IOrderShipment;

/** Order sorting fields */
export enum IOrderSortFieldEnum {
  CreatedAt = 'CREATED_AT',
  LineItems = 'LINE_ITEMS',
  OrderNumber = 'ORDER_NUMBER',
  SalesChannel = 'SALES_CHANNEL',
  ShipTo = 'SHIP_TO',
  Status = 'STATUS',
  Units = 'UNITS',
  UpdatedAt = 'UPDATED_AT'
}

/** Contains the statistics of the order. This object should be used to access the statistics of the order. */
export type IOrderStats = {
  __typename?: 'OrderStats';
  /** The estimated weight of the order. This is the sum of the weight of each item in the order. */
  estimatedWeight: Scalars['Float'];
  /** The total number of different products in the order. */
  totalItems: Scalars['Int'];
  /** The total price of the order. This is the sum of the price of each item in the order. */
  totalPrice: Scalars['Float'];
  /** The total number of units in the order. This is the sum of the quantity of each item in the order. */
  totalUnits: Scalars['Int'];
};

/** The order status type. This type represents the status of an order in the system. */
export type IOrderStatus = {
  __typename?: 'OrderStatus';
  createdAt: Scalars['ISO8601DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  name: IOrderStatusEnum;
  /** The order object of the status. */
  order: IOrder;
  orderId: Scalars['ID'];
  /** The party that processed the status. */
  processedBy?: Maybe<IParty>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The order status type. This type represents the status of an order in the system. */
export type IOrderStatusAlert = {
  __typename?: 'OrderStatusAlert';
  additionalInfo?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  message: Scalars['String'];
  /** The order object of the status. */
  order: IOrder;
  orderId: Scalars['ID'];
  severity: IOrderStatusAlertSeverityEnum;
  solution?: Maybe<Scalars['String']>;
};

export enum IOrderStatusAlertSeverityEnum {
  /** Alert */
  Alert = 'ALERT',
  /** Error */
  Error = 'ERROR'
}

/** The status of the order. */
export enum IOrderStatusEnum {
  /** Allocated */
  Allocated = 'ALLOCATED',
  /** Canceled */
  Canceled = 'CANCELED',
  /** In Progress */
  InProgress = 'IN_PROGRESS',
  /** On Hold */
  OnHold = 'ON_HOLD',
  /** Ordered */
  Ordered = 'ORDERED',
  /** Partially Shipped */
  PartiallyShipped = 'PARTIALLY_SHIPPED',
  /** Pending */
  Pending = 'PENDING',
  /** Shipped */
  Shipped = 'SHIPPED'
}

/** The order tag type. This type represents a tag assigned to an order. */
export type IOrderTag = {
  __typename?: 'OrderTag';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  /** The type of the tag. */
  tagType: IOrderTagTypeEnum;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The input object for an order tag. */
export type IOrderTagInput = {
  /** The name of the tag. */
  name: Scalars['String'];
  /** The type of the tag. */
  tagType: IOrderTagTypeEnum;
};

/** The type of the order tag. */
export enum IOrderTagTypeEnum {
  /** External order tag. */
  External = 'EXTERNAL',
  /** Internal order tag. */
  Internal = 'INTERNAL'
}

export type IOrderUpdatesPayload = {
  __typename?: 'OrderUpdatesPayload';
  /** Additional data related to the event. */
  additionalData?: Maybe<Scalars['JSON']>;
  /** The event that occurred. */
  event?: Maybe<Scalars['String']>;
  /** The new value of the field. */
  newValue?: Maybe<Scalars['String']>;
  /** The Order ID for which updates will be received. */
  orderId?: Maybe<Scalars['ID']>;
  /** The previous value of the field. */
  previousValue?: Maybe<Scalars['String']>;
};

/** The type of package */
export enum IPackageTypeEnum {
  /** Box */
  Box = 'BOX',
  /** Custom */
  Custom = 'CUSTOM',
  /** Envelope */
  Envelope = 'ENVELOPE',
  /** Package */
  Package = 'PACKAGE',
  /** Tube */
  Tube = 'TUBE'
}

/** Types of packages */
export enum IPackageTypesEnum {
  Box = 'BOX',
  BubbleMailer = 'BUBBLE_MAILER',
  Crate = 'CRATE',
  Custom = 'CUSTOM',
  Envelope = 'ENVELOPE',
  FlatRatePackaging = 'FLAT_RATE_PACKAGING',
  Package = 'PACKAGE',
  Pallet = 'PALLET',
  Polymailer = 'POLYMAILER',
  Tube = 'TUBE'
}

/** Information about pagination in a connection. */
export type IPageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type IPallet = {
  __typename?: 'Pallet';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  gtin?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['ID']>;
  length?: Maybe<Scalars['Decimal']>;
  quantity?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  weight?: Maybe<Scalars['Decimal']>;
  width?: Maybe<Scalars['Decimal']>;
};

export type IParty = {
  __typename?: 'Party';
  createdAt: Scalars['ISO8601DateTime'];
  /** Indicates if the party is the current selected party. This field applies only for companies. */
  current?: Maybe<Scalars['Boolean']>;
  /** The details of the party. The details are different for every party type. For example, a company has a name, a person has a first name and a last name. */
  details: IPartyDetails;
  /** The relationships of the party in a human readable format. */
  humanizedRelationships?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  /** The type of party. Party can have different types and every type has different attributes. For example, a company has a name, a person has a first name and a last name. */
  partyType?: Maybe<Scalars['String']>;
  /** The relationships of the party. A relationship is a connection between two parties. For example, a person can be an employee of a company. */
  relationships: Array<IRelationship>;
  roles?: Maybe<Array<IRole>>;
  updatedAt: Scalars['ISO8601DateTime'];
  /** The user associated with the party. Only persons can have a user associated with them. */
  user?: Maybe<IUser>;
};

/** The connection type for Party. */
export type IPartyConnection = {
  __typename?: 'PartyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IPartyEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IParty>>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** Total count of items in the connection, without considering pagination. */
  totalCount: Scalars['Int'];
};

/** Used to return the details of a party. Possible party types in MvnifestAI are Persons, Companies, and Integrations. */
export type IPartyDetails = IApiClientDetails | ICompanyDetails | IIntegrationDetails | IPersonDetails;

/** An edge in a connection. */
export type IPartyEdge = {
  __typename?: 'PartyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<IParty>;
};

export type IPartyType = {
  __typename?: 'PartyType';
  createdAt: Scalars['ISO8601DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: IPartyTypeEnum;
  prettyName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Party types are used to classify parties in the system. A party is an actor in the system capable of performing actions and can can be categorized in different types. For instance, a party can be a person or an organization. This enum is used to classify parties in different types. */
export enum IPartyTypeEnum {
  /** Indicates that the party is an organization. */
  Company = 'COMPANY',
  /** Indicates that the party is an integration. */
  Integration = 'INTEGRATION',
  /** Indicates that the party is a person. */
  Person = 'PERSON'
}

export type IPerson = {
  __typename?: 'Person';
  createdAt: Scalars['ISO8601DateTime'];
  /** Indicates if the party is the current selected party. This field applies only for companies. */
  current?: Maybe<Scalars['Boolean']>;
  /** The details of the party. The details are different for every party type. For example, a company has a name, a person has a first name and a last name. */
  details: IPersonDetails;
  /** The relationships of the party in a human readable format. */
  humanizedRelationships?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  /** The type of party. Party can have different types and every type has different attributes. For example, a company has a name, a person has a first name and a last name. */
  partyType?: Maybe<Scalars['String']>;
  /** The relationships of the party. A relationship is a connection between two parties. For example, a person can be an employee of a company. */
  relationships: Array<IRelationship>;
  roles?: Maybe<Array<IRole>>;
  updatedAt: Scalars['ISO8601DateTime'];
  /** The user associated with the party. Only persons can have a user associated with them. */
  user?: Maybe<IUser>;
};

/** Details of a person */
export type IPersonDetails = {
  __typename?: 'PersonDetails';
  avatar?: Maybe<Scalars['Url']>;
  createdAt: Scalars['ISO8601DateTime'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  picture?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Filter persons by the given criteria. */
export type IPersonFilterInput = {
  /** Filter persons by registration date less than. */
  endDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Keyword to search for in the persons. This filters by name, email. */
  keyword?: InputMaybe<Scalars['String']>;
  /** Filter persons by role type. */
  roleType?: InputMaybe<Scalars['String']>;
  /** Field to sort the inventory items by. */
  sortField?: InputMaybe<IPersonSortFieldsEnum>;
  /** Sort type for persons */
  sortType?: InputMaybe<ISortTypeEnum>;
  /** Filter persons by registration date. */
  startDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Filter persons by verified status. */
  verified?: InputMaybe<Scalars['Boolean']>;
};

/** Fields to sort persons by. */
export enum IPersonSortFieldsEnum {
  /** Sort by created at date. */
  Created = 'CREATED',
  /** Sort by email. */
  Email = 'EMAIL',
  /** Sort by first name. */
  FirstName = 'FIRST_NAME',
  /** Sort by last name. */
  LastName = 'LAST_NAME',
  /** Sort by status. */
  Status = 'STATUS',
  /** Sort by updated at date. */
  Updated = 'UPDATED'
}

/** The status of a process. */
export enum IProcessStatusEnum {
  /** The process has been cancelled. */
  Cancelled = 'CANCELLED',
  /** The process has been completed. */
  Completed = 'COMPLETED',
  /** The process has failed. */
  Failed = 'FAILED',
  /** The process is pending. */
  Pending = 'PENDING',
  /** The process is currently being processed. */
  Processing = 'PROCESSING',
  /** The process is waiting for something to happen. */
  Waiting = 'WAITING'
}

export type IProduct = {
  __typename?: 'Product';
  brand: IBrand;
  brandId: Scalars['ID'];
  bulletPoints?: Maybe<Array<Scalars['String']>>;
  categories?: Maybe<Array<IProductCategory>>;
  color?: Maybe<IColor>;
  createdAt: Scalars['ISO8601DateTime'];
  /** The "Data Quality" field denotes the percentage of fields that have been filled out for a product. This information aids in determining the completeness of a product's information. */
  dataQuality: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Decimal']>;
  id: Scalars['ID'];
  image?: Maybe<IProductImage>;
  images?: Maybe<Array<IProductImage>>;
  innerPack: Scalars['Boolean'];
  length?: Maybe<Scalars['Decimal']>;
  masterCarton: Scalars['Boolean'];
  name: Scalars['String'];
  pallet: Scalars['Boolean'];
  parent?: Maybe<IProduct>;
  price?: Maybe<Scalars['Decimal']>;
  productCustoms?: Maybe<ICustoms>;
  productInnerPack?: Maybe<IInnerPack>;
  productMasterCarton?: Maybe<IMasterCarton>;
  productPallet?: Maybe<IPallet>;
  productPurchasing?: Maybe<IPurchasing>;
  productShipping?: Maybe<IShipping>;
  productType: IProductTypeEnum;
  productTypeName: Scalars['String'];
  ship: Scalars['Boolean'];
  size?: Maybe<ISize>;
  sku?: Maybe<Scalars['String']>;
  status: IProductStatusEnum;
  style?: Maybe<IStyle>;
  upc?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  /** The "Volume" field denotes the amount of space occupied by a product in three dimensions (length, width, height). This information aids in optimizing storage, packaging, and shipping calculations. */
  volume?: Maybe<Scalars['Decimal']>;
  weight?: Maybe<Scalars['Decimal']>;
  width?: Maybe<Scalars['Decimal']>;
};

export type IProductCategory = {
  __typename?: 'ProductCategory';
  brand: IBrand;
  brandId: Scalars['ID'];
  categoryType: ICategoryTypeEnum;
  children?: Maybe<Array<IProductCategory>>;
  createdAt: Scalars['ISO8601DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  parent?: Maybe<IProductCategory>;
  parentId?: Maybe<Scalars['ID']>;
  products?: Maybe<Array<IProduct>>;
  status: IProductStatusEnum;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for ProductCategory. */
export type IProductCategoryConnection = {
  __typename?: 'ProductCategoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IProductCategoryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IProductCategory>>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** Total count of items in the connection, without considering pagination. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type IProductCategoryEdge = {
  __typename?: 'ProductCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<IProductCategory>;
};

/** The connection type for Product. */
export type IProductConnection = {
  __typename?: 'ProductConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IProductEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IProduct>>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** Total count of items in the connection, without considering pagination. */
  totalCount: Scalars['Int'];
};

/** Product custom input */
export type IProductCustomsInput = {
  code?: InputMaybe<Scalars['String']>;
  defaultValue?: InputMaybe<Scalars['Decimal']>;
  name?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
};

/** An edge in a connection. */
export type IProductEdge = {
  __typename?: 'ProductEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<IProduct>;
};

/** Filtering options for products. */
export type IProductFilterInput = {
  /** IDs of the brands to get products for. */
  brandIds?: InputMaybe<Array<Scalars['ID']>>;
  description?: InputMaybe<Scalars['String']>;
  innerPack?: InputMaybe<Scalars['Boolean']>;
  /** Filter products by keyword. Searches in name, SKU, UPC, product type, and description and brand name. This filter is case-insensitive and should have a minimum length of 3 characters. If a keyword with less than 3 characters is provided, it will be ignored. */
  keyword?: InputMaybe<Scalars['String']>;
  masterCarton?: InputMaybe<Scalars['Boolean']>;
  /** Filter products by name. */
  name?: InputMaybe<Scalars['String']>;
  pallet?: InputMaybe<Scalars['Boolean']>;
  productType?: InputMaybe<IProductTypeEnum>;
  /** Filter products by SKU. */
  sku?: InputMaybe<Scalars['String']>;
  /** Field to sort orders by. */
  sortField?: InputMaybe<IProductSortFieldEnum>;
  /** Sort type for orders. */
  sortType?: InputMaybe<ISortTypeEnum>;
  status?: InputMaybe<IProductStatusEnum>;
  /** Filter products by UPC. */
  upc?: InputMaybe<Scalars['String']>;
};

export type IProductImage = {
  __typename?: 'ProductImage';
  altText?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  height?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  position?: Maybe<Scalars['Int']>;
  product: IProduct;
  productId: Scalars['ID'];
  src: Scalars['Url'];
  updatedAt: Scalars['ISO8601DateTime'];
  width?: Maybe<Scalars['Int']>;
};

/** Attributes for adding a product image */
export type IProductImageInput = {
  altText?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  position?: InputMaybe<Scalars['Int']>;
  src: Scalars['Url'];
  width?: InputMaybe<Scalars['Int']>;
};

/** Attributes for a product's inner pack */
export type IProductInnerPackInput = {
  gtin?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Decimal']>;
  length?: InputMaybe<Scalars['Decimal']>;
  quantity?: InputMaybe<Scalars['Int']>;
  weight?: InputMaybe<Scalars['Decimal']>;
  weightFactor?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Decimal']>;
};

/** Attributes for creating a new product master carton */
export type IProductMasterCartonInput = {
  gtin?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Decimal']>;
  length?: InputMaybe<Scalars['Decimal']>;
  quantity?: InputMaybe<Scalars['Int']>;
  weight?: InputMaybe<Scalars['Decimal']>;
  weightFactor?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Decimal']>;
};

/** Attributes for creating a new product pallet */
export type IProductPalletInput = {
  gtin?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Decimal']>;
  length?: InputMaybe<Scalars['Decimal']>;
  quantity?: InputMaybe<Scalars['Int']>;
  weight?: InputMaybe<Scalars['Decimal']>;
  width?: InputMaybe<Scalars['Decimal']>;
};

/** Attributes for creating a new product purchasing */
export type IProductPurchasingInput = {
  bomCost?: InputMaybe<Scalars['Decimal']>;
  inboundFreightCost?: InputMaybe<Scalars['Decimal']>;
  incoterms?: InputMaybe<Scalars['String']>;
  landedCost?: InputMaybe<Scalars['Decimal']>;
  leadTime?: InputMaybe<Scalars['Int']>;
  moq?: InputMaybe<Scalars['Int']>;
  packagingCost?: InputMaybe<Scalars['Decimal']>;
  portOfExport?: InputMaybe<Scalars['String']>;
  productPackaging?: InputMaybe<Scalars['Url']>;
  productSpecs?: InputMaybe<Scalars['Url']>;
  purchaserId?: InputMaybe<Scalars['ID']>;
  supplier?: InputMaybe<Scalars['String']>;
  supplierPartNumber?: InputMaybe<Scalars['String']>;
  supplierSku?: InputMaybe<Scalars['String']>;
  unitCost?: InputMaybe<Scalars['Decimal']>;
};

/** Attributes for creating a new product shipping */
export type IProductShippingInput = {
  height?: InputMaybe<Scalars['Decimal']>;
  length?: InputMaybe<Scalars['Decimal']>;
  packageType?: InputMaybe<IPackageTypesEnum>;
  shipReadyPackaging?: InputMaybe<Scalars['Boolean']>;
  shippingPackage?: InputMaybe<IShippingPackagesEnum>;
  weight?: InputMaybe<Scalars['Decimal']>;
  weightFactor?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Decimal']>;
};

export enum IProductSortFieldEnum {
  BomCost = 'BOM_COST',
  CreatedAt = 'CREATED_AT',
  LandedCost = 'LANDED_COST',
  Name = 'NAME',
  ShippingWeight = 'SHIPPING_WEIGHT',
  Sku = 'SKU',
  Upc = 'UPC'
}

export enum IProductStatusEnum {
  /** Active categories */
  Active = 'ACTIVE',
  /** Inactive categories */
  Inactive = 'INACTIVE'
}

export enum IProductTypeEnum {
  BaseItem = 'BASE_ITEM',
  Kit = 'KIT',
  NonInventory = 'NON_INVENTORY'
}

export type IPurchasing = {
  __typename?: 'Purchasing';
  bomCost?: Maybe<Scalars['Decimal']>;
  createdAt: Scalars['ISO8601DateTime'];
  inboundFreightCost?: Maybe<Scalars['Decimal']>;
  incoterms?: Maybe<Scalars['String']>;
  landedCost?: Maybe<Scalars['Decimal']>;
  leadTime?: Maybe<Scalars['Int']>;
  moq?: Maybe<Scalars['Int']>;
  packagingCost?: Maybe<Scalars['Decimal']>;
  portOfExport?: Maybe<Scalars['String']>;
  productPackaging?: Maybe<Scalars['Url']>;
  productSpecs?: Maybe<Scalars['Url']>;
  purchaser?: Maybe<IParty>;
  purchaserId?: Maybe<Scalars['ID']>;
  supplier?: Maybe<Scalars['String']>;
  supplierPartNumber?: Maybe<Scalars['String']>;
  supplierSku?: Maybe<Scalars['String']>;
  unitCost?: Maybe<Scalars['Decimal']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type IQuery = {
  __typename?: 'Query';
  /** Get all roles allowed by party type. */
  allowedRoles: Array<IAllowedRole>;
  /** Retrieve the details of an API client. */
  apiClient: IApiClient;
  /** Get the list of API clients registered in the system */
  apiClients: IApiClientConnection;
  /** Retrieve the details of an API key */
  apiKey: IApiKey;
  /** Get a single ASN by ID */
  asn: IAsn;
  /** Get all available items for adding to an ASN. */
  asnAvailableItems: Array<IAsnAvailableItem>;
  /** This query returns the available filters for the ASN list page, and can be used to retrieve the filters that can be applied to the `listAsns` query. */
  availableAsnFilters: IAsnFilter;
  /** Retrieve the available options to filter integrations */
  availableIntegrationFilters: IIntegrationFilter;
  /**
   * This query returns all available inventory filters. These filters are used to filter the inventory items.
   *
   * Options are returned according the user's permissions.
   */
  availableInventoryFilters: IInventoryFilter;
  /**
   * This query returns all available location filters for a warehouse. These filters are used to filter the locations in the warehouse.
   *
   * Options are returned according the user's permissions.
   */
  availableLocationFilters: ILocationFilter;
  /**
   * The `AvailableOrderFilters` query is used to retrieve the available filters for orders. This includes brands, sales channels, and statuses. The user must be authenticated to use this query.
   *
   * ## Response
   * The query returns a list of available brands, sales channels, and statuses for orders. Each item in these lists is an object containing a `name` and a `value`.
   *
   * ## Errors
   * If the user is not authenticated, the query will return an error with the message "You must be logged in to access this resource" and a status code of `401`.
   */
  availableOrderFilters: IOrderFilter;
  /** Get a brand by ID */
  brand?: Maybe<IBrand>;
  /** Get all brands according to roles of the current party. */
  brands: Array<IBrand>;
  /**
   * Fetches all carrier services.
   * Arguments:
   * - `carrier_id`: ID of the carrier (required).
   * Returns a list of carrier services ordered by name.
   * Possible errors:
   * - `NotFoundError`: If the carrier is not found.
   *
   */
  carrierServices: Array<ICarrierService>;
  /**
   * Get the list of carriers for a brand. This query returns a list of carriers that are either global or belong to a specific brand. The brand can be specified by the `brand_id` argument. If `brand_id` is not provided, the brand will be determined by the `X-Brand-Id` header.
   *
   * ### Arguments
   * | Name | Type | Description |
   * | ---- | ---- | ----------- |
   * | brand_id | ID | The brand ID to filter the carriers by. If not provided, will use the brand provided in the `X-Brand-Id` header. |
   *
   *
   * ### Errors
   * This query may return the following errors:
   * - `NotFoundError`: If the provided `brand_id` is not a valid brand ID.
   *
   *
   * ### Return Value
   * This query returns a list of `CarrierType` objects. Each `CarrierType` object represents a carrier that is either global or belongs to the specified brand. The carriers are ordered by their name and only carriers with a status of 'ACTIVE' are returned.
   */
  carriers: Array<ICarrier>;
  /**
   * Retrieve the product categories. The categories will be search in the current brand.
   *
   * The party should have the `list_categories` permission granted.
   *
   * ### Headers:
   *
   * | Header | Value | Required |
   * | ------ | ----- | -------- |
   * | Authorization | `Bearer [token]` | Yes |
   * | X-Brand-Id | `[brand-id]` | Yes |
   */
  categories: IProductCategoryConnection;
  /**
   * Retrieve a product category. The category will be search in the current brand.
   *
   * The party should have the `get_category` permission granted.
   *
   * ### Headers:
   *
   * | Header | Value | Required |
   * | ------ | ----- | -------- |
   * | Authorization | `Bearer [token]` | Yes |
   * | X-Brand-Id | `[brand-id]` | Yes |
   */
  category: IProductCategory;
  /** Get all colors belonging to a brand */
  colors: Array<IColor>;
  /** Get all companies that the user is associated with.If the user is a super admin, return all companies, otherwise returnthe companies that the user is associated with. */
  companies: Array<ICompany>;
  /** Get a specific company by ID. The user must be logged in and have the necessary permissions to view the company. */
  company: IParty;
  countries: Array<ICountry>;
  /** Get all external relations for a brand on a specific object type */
  externalRelations: Array<IExternalObject>;
  /** Check if a feature flag is enabled */
  ffe: Array<IFeatureFlagEnabled>;
  /** Get a single integration by ID. */
  integration: IIntegration;
  /** Get the available actions for a given integration. This query will return the actions that can be performed by the user and the actions that can be performed by the integration itself. */
  integrationActions: Array<IIntegrationAction>;
  /** Get the settings options for an integration. The return of this query is defined by the integration type. */
  integrationSettingsOptions?: Maybe<Array<IIntegrationSettingCategory>>;
  /** Get available integration types. */
  integrationTypes?: Maybe<Array<IIntegrationType>>;
  /** Get all integrations for a brand */
  integrations: IIntegrationConnection;
  /** Get a list of inventory adjustment reasons. This is a list of reasons that can be used to explain why an inventory adjustment was made. */
  inventoryAdjustmentReasons: Array<IInventoryAdjustmentReason>;
  /** Get a single inventory item by ID. */
  inventoryItem: IInventoryItem;
  /** Get all ASNs and provide filtering options */
  listAsns?: Maybe<IAsnConnection>;
  /** Get all available items for adding to an order. */
  listAvailableItems: IInventoryItemConnection;
  /** Get all inventory items filtered by various criteria. */
  listInventory: IInventoryItemConnection;
  /** Get the details of a location */
  location: ILocation;
  /** Get all locations for a company or warehouse */
  locations: ILocationConnection;
  /** Get current user information */
  me: IUser;
  /**
   * The `Notes` query is used to retrieve notes associated with a specific object, referred to as the 'notable' object. It requires a `notable_type` and `notable_id` to identify the notable object, and an optional `NoteFiltersInput` object to filter the results. Each field in the `NoteFiltersInput` corresponds to a specific attribute in the notes and is optional. If a field is provided, the query will return only the notes that match the provided value for that field.
   *
   * | Argument | Type | Description |
   * | --- | --- | --- |
   * | `notable_type` | Enum | The type of the notable object. |
   * | `notable_id` | ID | The ID of the notable object. |
   * | `filters` | `NoteFiltersInput` | An object used to filter the results of the Notes query. |
   *
   * The query returns an array of `NoteType` objects. Each `NoteType` object represents a note and includes the following fields: `content`, `author_id`, `notable_type`, `notable_id`, `created_at`, and `updated_at`.
   *
   * Possible errors include `NotableError` if the `notable_id` and `notable_type` fields do not correspond to a valid notable object, and `AuthenticationError` if the user is not authenticated.
   */
  notes: INoteConnection;
  /** Get all the details of an order */
  order?: Maybe<IOrder>;
  /** Get all order items for a given order */
  orderItems: Array<IOrderItem>;
  /**
   * Get a list of filtered orders. This query allows you to retrieve a list of orders based on various filters.
   *
   * ## Filters
   * | Filter | Description | Type | Required |
   * | ------ | ----------- | ---- | -------- |
   * | `brand_ids` | Filter orders by brand IDs. | Array of Integers | No |
   * | `keyword` | Search orders by keyword. | String | No |
   * | `start_date` | Filter orders created after this date. | String (YYYY-MM-DD) | No |
   * | `end_date` | Filter orders created before this date. | String (YYYY-MM-DD) | No |
   * | `status` | Filter orders by status. | Array of Strings | No |
   * | `sales_channel_ids` | Filter orders by sales channel IDs. | Array of Integers | No |
   * | `fulfillable` | Filter orders by fulfillability. | Boolean | No |
   * | `created_by_id` | Filter orders by the ID of the user who created them. | Integer | No |
   * | `responsible_id` | Filter orders by the ID of the responsible user. | Integer | No |
   * | `sort_field` | Field to sort the orders by. | String | No |
   * | `sort_type` | Type of sort (ASC or DESC). | String | No |
   *
   * ## Returns
   * Returns a list of orders that match the provided filters. Each order includes its associated data.
   *
   * ## Errors
   * - `BrandNotSelectedError`: Raised when no brand is specified and the current user is not a super admin.
   * - `BadRequest`: Raised when the provided filters are not valid.
   */
  orders?: Maybe<IOrderConnection>;
  /** Get all companies that the user is associated with.If the user is a super admin, return all companies, otherwise returnthe companies that the user is associated with. */
  paginatedCompanies: ICompanyConnection;
  /** Find a party by UUID */
  party?: Maybe<IParty>;
  /** Get all persons registered in the system, optionally filtered by company or brand. */
  persons: IPartyConnection;
  /** Get information about a product */
  product?: Maybe<IProduct>;
  /**
   * Get all products for a company or brand. If a brand is provided, it will return all products for that brand. If a brand is not provided, it will return all products for all brands in the company.
   *
   * | Header | Value | Required |
   * | ------ | ----- | -------- |
   * | `Authorization` | Bearer {token} | Yes |
   * | `X-Company-Id` | {company_id} | Yes |
   * | `X-Brand-Id` | {brand_id} | No |
   */
  products?: Maybe<IProductConnection>;
  /** Query external products for a specific integration. */
  productsExternal: Array<IExternalProducts>;
  /** Get all relationship types. */
  relationshipTypes: Array<IRelationshipType>;
  /** Get all relationships for a person. */
  relationships: Array<IRelationship>;
  /**
   * Get all role types available in the system. Optionally filter by domain and party type.
   *
   * You need to have the permissions `get_role_types` to access this query, and only system admins can access the role types from the `SYSTEM` domain.
   */
  roleTypes: Array<IRoleType>;
  /** Get the details of a sales channel */
  salesChannel?: Maybe<ISalesChannel>;
  /** Query external sales channels for a specific integration. */
  salesChannelExternal: Array<IExternalSalesChannel>;
  /** Get a list of sales channels */
  salesChannels?: Maybe<ISalesChannelConnection>;
  /** Get all shipping carrier services for a brand */
  shippingCarrierServices: Array<IShippingCarrierService>;
  /** Get all sizes belonging to a brand */
  sizes: Array<ISize>;
  /** Get the states filtered by country */
  states: Array<IState>;
  /** Get all styles belonging to a brand */
  styles: Array<IStyle>;
  /**
   * The `SystemLogs` query is used to retrieve log entries from the system. It requires a `SystemLogFilterInput` object as an argument, which is used to filter the results. Each field in the `SystemLogFilterInput` corresponds to a specific attribute in the log entries and is optional. If a field is provided, the query will return only the log entries that match the provided value for that field.
   *
   * | Argument | Type | Description |
   * | --- | --- | --- |
   * | `filters` | `SystemLogFilterInput` | An object used to filter the results of the SystemLog query. |
   *
   * Please note that the `entity_id` and `entity_type` fields must be provided, or an error will be raised. The `log_type`, `operation`, and `message` fields are optional and can be used to further filter the results.
   *
   * The query returns an array of `SystemLogType` objects. Each `SystemLogType` object represents a log entry and includes the following fields: `log_type`, `operation`, `message`, `entity_id`, `entity_type`, `created_at`, and `updated_at`.
   *
   * Possible errors include `EntityError` if the `entity_id` and `entity_type` fields are not provided, and `AuthenticationError` if the user is not authenticated.
   */
  systemLogs: Array<ISystemLog>;
  /**
   * Validate a party session. This query will return the following fields:
   *
   * - `valid`: A boolean indicating whether the session is valid or not.
   * - `valid_until`: The expiration date of the session.
   * - `seconds_left`: The number of seconds left before the session expires.
   *
   * If the session is not valid or has already expired, all fields will be `nil`.
   */
  validatePartySession?: Maybe<ISessionValidity>;
  /** Get a single warehouse by ID. The party should have permissions for the `get_warehouse_details` action. */
  warehouse: IWarehouse;
  /** Query external warehouses for a specific integration. */
  warehouseExternal: Array<IExternalWarehouse>;
  /** Get all warehouses under the current company */
  warehouses: IWarehouseConnection;
};


export type IQueryAllowedRolesArgs = {
  partyType?: InputMaybe<IPartyTypeEnum>;
  roleType?: InputMaybe<IRoleTypeEnum>;
};


export type IQueryApiClientArgs = {
  id: Scalars['ID'];
};


export type IQueryApiClientsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clientType?: InputMaybe<IApiClientTypeEnum>;
  first?: InputMaybe<Scalars['Int']>;
  keyword?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<IApiClientsSortFieldEnum>;
  sortType?: InputMaybe<ISortTypeEnum>;
};


export type IQueryApiKeyArgs = {
  id: Scalars['ID'];
};


export type IQueryAsnArgs = {
  id: Scalars['ID'];
};


export type IQueryAsnAvailableItemsArgs = {
  brandId?: InputMaybe<Scalars['ID']>;
  keyword?: InputMaybe<Scalars['String']>;
  resultsLimit?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<IItemsSortByEnum>;
  sortType?: InputMaybe<ISortTypeEnum>;
};


export type IQueryBrandArgs = {
  id: Scalars['ID'];
};


export type IQueryBrandsArgs = {
  companyId?: InputMaybe<Scalars['ID']>;
  responsible?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


export type IQueryCarrierServicesArgs = {
  carrierId: Scalars['ID'];
};


export type IQueryCarriersArgs = {
  brandId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<IStatusEnum>;
};


export type IQueryCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<ICategoryFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<ICategoryFieldsEnum>;
  sortType?: InputMaybe<ISortTypeEnum>;
};


export type IQueryCategoryArgs = {
  id: Scalars['ID'];
};


export type IQueryColorsArgs = {
  brandId?: InputMaybe<Scalars['ID']>;
};


export type IQueryCompanyArgs = {
  id: Scalars['ID'];
};


export type IQueryCountriesArgs = {
  filters?: InputMaybe<ICountryFiltersInput>;
};


export type IQueryExternalRelationsArgs = {
  brandId: Scalars['ID'];
  integrationId: Scalars['ID'];
  objectType: IExternalObjectTypeEnum;
};


export type IQueryFfeArgs = {
  keys: Array<Scalars['String']>;
};


export type IQueryIntegrationArgs = {
  integrationId: Scalars['ID'];
};


export type IQueryIntegrationActionsArgs = {
  actionsType?: InputMaybe<IIntegrationActionEnum>;
  brandId?: InputMaybe<Scalars['ID']>;
  integrationId: Scalars['ID'];
};


export type IQueryIntegrationSettingsOptionsArgs = {
  integrationType: IIntegrationTypeEnum;
};


export type IQueryIntegrationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<IIntegrationFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type IQueryInventoryAdjustmentReasonsArgs = {
  addCode?: InputMaybe<Scalars['Boolean']>;
};


export type IQueryInventoryItemArgs = {
  id: Scalars['ID'];
};


export type IQueryListAsnsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<IAsnFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type IQueryListAvailableItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<IInventoryFiltersInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type IQueryListInventoryArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<IInventoryFiltersInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type IQueryLocationArgs = {
  id: Scalars['ID'];
};


export type IQueryLocationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<ILocationFiltersInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type IQueryNotesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<INoteFiltersInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  notableId: Scalars['ID'];
  notableType: INotableObjectEnum;
};


export type IQueryOrderArgs = {
  orderId: Scalars['ID'];
};


export type IQueryOrderItemsArgs = {
  filters?: InputMaybe<IOrderItemFilterInput>;
  orderId: Scalars['ID'];
};


export type IQueryOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<IOrderFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type IQueryPaginatedCompaniesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<ICompanyFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type IQueryPartyArgs = {
  companyId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
};


export type IQueryPersonsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  brandId?: InputMaybe<Scalars['ID']>;
  companyId?: InputMaybe<Scalars['ID']>;
  filters?: InputMaybe<IPersonFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type IQueryProductArgs = {
  id: Scalars['ID'];
};


export type IQueryProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<IProductFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type IQueryProductsExternalArgs = {
  integrationId: Scalars['ID'];
  keyword?: InputMaybe<Scalars['String']>;
};


export type IQueryRelationshipsArgs = {
  companyId: Scalars['ID'];
  partyId?: InputMaybe<Scalars['ID']>;
};


export type IQueryRoleTypesArgs = {
  domain?: InputMaybe<IDomainEnum>;
  partyType?: InputMaybe<IPartyTypeEnum>;
};


export type IQuerySalesChannelArgs = {
  id: Scalars['ID'];
};


export type IQuerySalesChannelExternalArgs = {
  integrationId: Scalars['ID'];
  keyword?: InputMaybe<Scalars['String']>;
};


export type IQuerySalesChannelsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  brandId?: InputMaybe<Scalars['ID']>;
  filters?: InputMaybe<ISalesChannelFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type IQueryShippingCarrierServicesArgs = {
  brandId?: InputMaybe<Scalars['ID']>;
  keyword?: InputMaybe<Scalars['String']>;
};


export type IQuerySizesArgs = {
  brandId?: InputMaybe<Scalars['ID']>;
};


export type IQueryStatesArgs = {
  countryCode: Scalars['String'];
  filters?: InputMaybe<IStateFiltersInput>;
};


export type IQueryStylesArgs = {
  brandId?: InputMaybe<Scalars['ID']>;
};


export type IQuerySystemLogsArgs = {
  filters: ISystemLogFilterInput;
};


export type IQueryWarehouseArgs = {
  id: Scalars['ID'];
};


export type IQueryWarehouseExternalArgs = {
  integrationId: Scalars['ID'];
  keyword?: InputMaybe<Scalars['String']>;
};


export type IQueryWarehousesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  brandId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  keyword?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<IWarehouseSortFieldsEnum>;
  sortType?: InputMaybe<ISortTypeEnum>;
};

/** Autogenerated input type of RegisterApiClient */
export type IRegisterApiClientInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The type of client. */
  clientType: IApiClientTypeEnum;
  companyId: Scalars['ID'];
  name: Scalars['String'];
};

/** Autogenerated input type of RegisterCarrier */
export type IRegisterCarrierInput = {
  /** The brand ID to which the carrier will be associated. If not provided, the carrier will be added globally. The party should have the permission 'register_carriers' to perform this operation. */
  brandId?: InputMaybe<Scalars['ID']>;
  category?: InputMaybe<ICarrierCategoryEnum>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /**
   * The internal code of the carrier. This argument is optional, and if not provided, the system will generate a unique code for the carrier.
   *
   * The code should be unique in the context of the carrier. If an existing code is provided, the system will ignore it and generate a new one.
   */
  code?: InputMaybe<Scalars['String']>;
  /**
   * Carrier description. A brief description of the carrier, including the type of services it provides and any other relevant information.
   *
   * The name should be unique in the context of the carrier.
   */
  description?: InputMaybe<Scalars['String']>;
  /**
   * Carrier name. Consider using the carrier's official name to prevent confusion and ensure consistency.
   *
   * The name should be unique in the context of the carrier.
   */
  name: Scalars['String'];
  status?: InputMaybe<IStatusEnum>;
};

/** Autogenerated input type of RegisterCarrierMapping */
export type IRegisterCarrierMappingInput = {
  /** The ID of the carrier in our system. */
  carrierId: Scalars['ID'];
  /** The code for the carrier in the external system. For instance, 'ups' or 'fedex'. */
  clientCode: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /**
   * The ID of the integration that will use this mapping. If not provided, the mapping will be for all integrations that has access to the carrier.
   *
   * Generally, carrier mappings are created to attend a specific integration, so this argument should be provided.
   */
  integrationId?: InputMaybe<Scalars['ID']>;
  /** The type of the integration that will use this mapping. For instance, 'SHOPIFY' or 'SHIPSTATION'. */
  integrationType: IIntegrationTypeEnum;
};

/** Autogenerated input type of RegisterCarrierService */
export type IRegisterCarrierServiceInput = {
  /** Carrier ID */
  carrierId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Code of the carrier service. If not provided, it will be generated by the system. */
  code?: InputMaybe<Scalars['String']>;
  /** Description of the carrier service */
  description?: InputMaybe<Scalars['String']>;
  /** Name of the carrier service */
  name: Scalars['String'];
  /** Status of the carrier service */
  status?: InputMaybe<IStatusEnum>;
};

/** Autogenerated input type of RegisterCarrierServiceMapping */
export type IRegisterCarrierServiceMappingInput = {
  carrierServiceId: Scalars['ID'];
  /** The code for the carrier service in the external system. For instance, 'ups_ground' or 'fedex_ground'. */
  clientCode: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /**
   * The ID of the integration that will use this mapping. If not provided, the mapping will be for all integrations that has access to the carrier service.
   *
   * Generally, carrier service mappings are created to attend a specific integration, so this argument should be provided.
   */
  integrationId?: InputMaybe<Scalars['ID']>;
  /** The type of the integration that will use this mapping. For instance, 'SHOPIFY' or 'SHIPSTATION'. */
  integrationType: IIntegrationTypeEnum;
};

/** Autogenerated input type of RegisterCompany */
export type IRegisterCompanyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Type of the company. This will determine the type of Brands that can be created under this company or if other companies can be created under this one. */
  companyType: ICompanyTypesEnum;
  /** Name of the company */
  name: Scalars['String'];
  /** ID of the party that will be the owner of the company. This party will be able to manage the company and its Brands and must be previously registered. */
  responsibleId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated input type of RegisterProductCategory */
export type IRegisterProductCategoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The description is optional. If not provided, it can be provided later. */
  description?: InputMaybe<Scalars['String']>;
  /** The name of the category. The name must be unique within the brand. If another category with the same name exists, the operation will fail. */
  name: Scalars['String'];
  /** The ID of the parent category. If the parent category is not specified, the category will be added to the root of the category tree, otherwise it will be added as a child of the specified parent category. This enable the category/subcategory hierarchy. */
  parentId?: InputMaybe<Scalars['ID']>;
  /** The status of the category. The default value is `ACTIVE`. */
  status?: InputMaybe<IProductStatusEnum>;
};

/** Autogenerated input type of RegisterWarehouse */
export type IRegisterWarehouseInput = {
  /** The address of the warehouse as a structured input. */
  address?: InputMaybe<IAddressInput>;
  /** The ID of the brand that the warehouse belongs to. */
  brandId?: InputMaybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the company that owns the warehouse. Performer must be a member of the company and be allowed to register a warehouse for it. */
  companyId?: InputMaybe<Scalars['ID']>;
  /** External data to be stored with the warehouse. */
  externalData?: InputMaybe<IWarehouseExternalDataInput>;
  /** The ID of the fulfillment integration used by the warehouse. */
  fulfillmentIntegrationId?: InputMaybe<Scalars['ID']>;
  /** The name of the warehouse. */
  name: Scalars['String'];
  /** The priority of the warehouse. Warehouses with higher priority are used first. */
  priority?: InputMaybe<Scalars['Int']>;
  /** Whether the warehouse is a residential building, such as a house or apartment. */
  residential?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<IStatusEnum>;
};

export type IRelationship = {
  __typename?: 'Relationship';
  createdAt: Scalars['ISO8601DateTime'];
  effectiveFrom?: Maybe<Scalars['ISO8601DateTime']>;
  effectiveTo?: Maybe<Scalars['ISO8601DateTime']>;
  from: IParty;
  humanized: Scalars['String'];
  id: Scalars['ID'];
  relationshipType: IRelationshipTypesEnum;
  to: IParty;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type IRelationshipType = {
  __typename?: 'RelationshipType';
  createdAt: Scalars['ISO8601DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  prettyName: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Possible types for relationships */
export enum IRelationshipTypesEnum {
  /** The person is an employee of the company */
  Employee = 'EMPLOYEE',
  /** The party is an integration of the company */
  Integration = 'INTEGRATION',
  /** The person is responsible for the company */
  Responsible = 'RESPONSIBLE'
}

/** Autogenerated input type of ReleaseOrder */
export type IReleaseOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderId: Scalars['ID'];
  /** The reason why the order is being released. */
  releaseReason?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of ReleaseOrder. */
export type IReleaseOrderPayload = {
  __typename?: 'ReleaseOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
  releaseReason?: Maybe<Scalars['String']>;
  status: IStatusResultEnum;
};

/** Autogenerated input type of RemoveIntegration */
export type IRemoveIntegrationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the integration to remove. */
  integrationId: Scalars['ID'];
};

/** Autogenerated return type of RemoveIntegration. */
export type IRemoveIntegrationPayload = {
  __typename?: 'RemoveIntegrationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  integrationId: Scalars['ID'];
  result: IStatusResultEnum;
};

/** Autogenerated input type of RemoveNote */
export type IRemoveNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The unique identifier of the note to be removed. */
  noteId: Scalars['ID'];
};

/** Autogenerated input type of RemoveOrderItem */
export type IRemoveOrderItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the order item to remove */
  id: Scalars['ID'];
};

/** Autogenerated return type of RemoveOrderItem. */
export type IRemoveOrderItemPayload = {
  __typename?: 'RemoveOrderItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The name of the removed item */
  removedItem?: Maybe<Scalars['String']>;
  /** Status of the operation */
  status: IStatusResultEnum;
};

/** Autogenerated input type of RemoveRelationship */
export type IRemoveRelationshipInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['ID'];
  relationshipId: Scalars['ID'];
};

/** Autogenerated input type of RequestOrderUnfulfillment */
export type IRequestOrderUnfulfillmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderId: Scalars['ID'];
};

/** Autogenerated return type of RequestOrderUnfulfillment. */
export type IRequestOrderUnfulfillmentPayload = {
  __typename?: 'RequestOrderUnfulfillmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
  result: IStatusResultEnum;
};

export type IRole = {
  __typename?: 'Role';
  brand?: Maybe<IBrand>;
  company?: Maybe<IParty>;
  createdAt: Scalars['ISO8601DateTime'];
  description?: Maybe<Scalars['String']>;
  domain?: Maybe<IRoleDomainEnum>;
  domainEntityId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name: IRoleTypeEnum;
  party: IParty;
  permissions?: Maybe<Array<Scalars['String']>>;
  prettyName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The domain of a role. This is used to determine which permissions are available to a role. */
export enum IRoleDomainEnum {
  Brand = 'BRAND',
  Company = 'COMPANY',
  System = 'SYSTEM'
}

export type IRoleType = {
  __typename?: 'RoleType';
  allowedParties?: Maybe<Array<IPartyType>>;
  createdAt: Scalars['ISO8601DateTime'];
  description?: Maybe<Scalars['String']>;
  domain?: Maybe<IRoleDomainEnum>;
  id: Scalars['ID'];
  name: IRoleTypeEnum;
  permissions?: Maybe<Array<Scalars['String']>>;
  prettyName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** All available role types. */
export enum IRoleTypeEnum {
  /** An account manager */
  AccountManager = 'ACCOUNT_MANAGER',
  /** A role for API clients with access to the orders scope */
  ApiOrders = 'API_ORDERS',
  /** Allowed to make any changes to their company */
  CompanyAdmin = 'COMPANY_ADMIN',
  /** Responsible for providing personalized support and ensuring customer success with the platform */
  CsAgent = 'CS_AGENT',
  /** A read-only user role with permission to view system information without ability to modify information or execute actions. */
  GuestUser = 'GUEST_USER',
  /** Allowed to make any changes to their Brand */
  LobAdmin = 'LOB_ADMIN',
  /** A role for integrations in charge of receiving orders from external systems */
  OrdersReceiver = 'ORDERS_RECEIVER',
  /** A role to handle orders shipping */
  OrdersShipper = 'ORDERS_SHIPPER',
  /** A role for integrations. Allow integrations to export products data to external systems */
  ProductsExporter = 'PRODUCTS_EXPORTER',
  /** The role to allow integrations to import products from external systems */
  ProductsImporter = 'PRODUCTS_IMPORTER',
  /** Allow to make any changes to the EC platform */
  SystemAdmin = 'SYSTEM_ADMIN',
  /** A role for an out of the box integration to an external WMS */
  WmsIntegration = 'WMS_INTEGRATION'
}

/** Autogenerated input type of RotateSessionToken */
export type IRotateSessionTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of RotateSessionToken. */
export type IRotateSessionTokenPayload = {
  __typename?: 'RotateSessionTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The number of seconds left until the token expires */
  secondsLeft?: Maybe<Scalars['Int']>;
  /** The new token for the session */
  token?: Maybe<Scalars['String']>;
  /** The new token's expiration date */
  validUntil?: Maybe<Scalars['ISO8601DateTime']>;
};

/** A routing strategy element for a sales channel. */
export enum IRoutingStrategyEnum {
  /** Building preference */
  BuildingPreference = 'BUILDING_PREFERENCE',
  /** Shortest distance */
  ShortestDistance = 'SHORTEST_DISTANCE',
  /** Single shipping */
  SingleShipping = 'SINGLE_SHIPPING'
}

/** Autogenerated input type of RunIntegrationAction */
export type IRunIntegrationActionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  command: Scalars['String'];
  integrationId: Scalars['ID'];
};

/** Autogenerated return type of RunIntegrationAction. */
export type IRunIntegrationActionPayload = {
  __typename?: 'RunIntegrationActionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  integrationId: Scalars['ID'];
  result: IStatusResultEnum;
};

/** The sales channel type. This type represents a sales channel in the system. */
export type ISalesChannel = {
  __typename?: 'SalesChannel';
  /** Indicates if orders from this channel should be automatically fulfilled. */
  autoFulfill: Scalars['Boolean'];
  brand: IBrand;
  brandId: Scalars['ID'];
  channelType?: Maybe<ISalesChannelTypeEnum>;
  codeName?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  customPackingSlip: Scalars['Boolean'];
  defaultChannel: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Indicates if orders from this channel should be routed locally or not. If false, Endless Commerce will use the roting information received from .external order sources. If true, Endless Commerce will use the routing strategy defined for this channel. */
  localRouting: Scalars['Boolean'];
  logoUrl?: Maybe<Scalars['Url']>;
  name: Scalars['String'];
  origin?: Maybe<ISalesChannelOriginEnum>;
  /** The routing strategy to use when routing orders from this channel. This strategy is used when `localRouting` is set to true. The routing strategy is a list of routing rules that are applied in order. */
  routingStrategy: Array<IRoutingStrategyEnum>;
  status: IStatusEnum;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for SalesChannel. */
export type ISalesChannelConnection = {
  __typename?: 'SalesChannelConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ISalesChannelEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ISalesChannel>>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** Total count of items in the connection, without considering pagination. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ISalesChannelEdge = {
  __typename?: 'SalesChannelEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ISalesChannel>;
};

/** Filtering options for sales channels */
export type ISalesChannelFilterInput = {
  channelType?: InputMaybe<ISalesChannelTypeEnum>;
  customPackingSlip?: InputMaybe<Scalars['Boolean']>;
  /** Keyword to search for in the sales channel name and description. */
  keyword?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<ISalesChannelOriginEnum>;
  status?: InputMaybe<IStatusEnum>;
};

/** The origin of the sales channel */
export enum ISalesChannelOriginEnum {
  /** Orders created via API */
  Api = 'API',
  /** Orders created via EDI */
  Edi = 'EDI',
  /** Orders created in an external system */
  External = 'EXTERNAL',
  /** Orders created via import */
  Imported = 'IMPORTED',
  /** Manually created orders */
  Manual = 'MANUAL'
}

/** Types of sales channels */
export enum ISalesChannelTypeEnum {
  /** Distributor sales channel */
  Distributor = 'DISTRIBUTOR',
  /** Drop ship sales channel */
  DropShip = 'DROP_SHIP',
  /** E-commerce sales channel */
  Ecommerce = 'ECOMMERCE',
  /** Marketplace sales channel */
  Marketplace = 'MARKETPLACE',
  /** Other sales channel */
  Other = 'OTHER',
  /** Retail sales channel */
  Retail = 'RETAIL',
  /** Wholesale sales channel */
  Wholesale = 'WHOLESALE'
}

/** Autogenerated input type of SendMagicLink */
export type ISendMagicLinkInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['Email'];
};

/** Autogenerated return type of SendMagicLink. */
export type ISendMagicLinkPayload = {
  __typename?: 'SendMagicLinkPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  result: IStatusResultEnum;
};

/** Session validity */
export type ISessionValidity = {
  __typename?: 'SessionValidity';
  /** Returns the number of seconds left until the session expires. */
  secondsLeft?: Maybe<Scalars['Int']>;
  /** Returns true if the session is valid, false otherwise. */
  valid: Scalars['Boolean'];
  /** Returns the expiration date time of the session. */
  validUntil?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Autogenerated input type of SetDefaultSalesChannel */
export type ISetDefaultSalesChannelInput = {
  /** The ID of the Brand */
  brandId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the Sales Channel to set as default */
  salesChannelId: Scalars['ID'];
};

/** Autogenerated return type of SetDefaultSalesChannel. */
export type ISetDefaultSalesChannelPayload = {
  __typename?: 'SetDefaultSalesChannelPayload';
  brandId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  result: IStatusResultEnum;
  salesChannelId: Scalars['ID'];
};

/** Autogenerated input type of SetupIntegration */
export type ISetupIntegrationInput = {
  /** The API key for the integration. This argument can be also used to store the main API key or secret for the integration. It is very important to store the main connection credential using this argument because it will be encrypted and stored in the database. */
  apiKey?: InputMaybe<Scalars['String']>;
  /** The API secret for the integration. This argument will be encrypted and stored in the database. */
  apiSecret?: InputMaybe<Scalars['String']>;
  /** The API token for the integration. This argument will be encrypted and stored in the database. */
  apiToken?: InputMaybe<Scalars['String']>;
  /** The brand id. If the header `X-Brand-Id` is provided then this argument is optional, otherwise it is required. */
  brandId?: InputMaybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  integrationType: IIntegrationTypeEnum;
  name: Scalars['String'];
  /** The roles that will be assigned to the integration. This argument is required and it must include at least one role. The roles determine the permissions that the integration will have, and the role should match with the actions that the integration will perform. */
  roles: Array<IRoleTypeEnum>;
  /** Additional settings for the integration. This argument can be used to store any additional settings for the integration different from the api_key, the api_secret or the api_token. */
  settings?: InputMaybe<Scalars['JSON']>;
};

/** Autogenerated input type of ShipOrderManually */
export type IShipOrderManuallyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The cost of the shipment */
  cost?: InputMaybe<Scalars['Decimal']>;
  /** The number of cartons in the shipment */
  numberOfCartons?: InputMaybe<Scalars['Int']>;
  /** The number of packages in the shipment */
  numberOfPackages?: InputMaybe<Scalars['Int']>;
  /** The number of pallets in the shipment */
  numberOfPallets?: InputMaybe<Scalars['Int']>;
  /** The ID of the order to ship */
  orderId: Scalars['ID'];
  /** The number of packages in the shipment */
  packageType?: InputMaybe<IPackageTypeEnum>;
  /** The company name to ship to */
  shipToCompany?: InputMaybe<Scalars['String']>;
  /** The email of the person to ship to */
  shipToEmail?: InputMaybe<Scalars['String']>;
  /** The name of the person to ship to */
  shipToName?: InputMaybe<Scalars['String']>;
  /** The phone number of the person to ship to */
  shipToPhone?: InputMaybe<Scalars['String']>;
  /** The date the order was shipped */
  shippedDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The address to ship to */
  shippingAddress?: InputMaybe<IAddressInput>;
  /** The carrier service that the order was shipped via */
  shippingCarrierService?: InputMaybe<Scalars['String']>;
  /** The tracking number for the shipment */
  trackingNumber: Scalars['String'];
  /** The URL to track the shipment */
  trackingUrl?: InputMaybe<Scalars['Url']>;
  /** The weight of the shipment */
  weight?: InputMaybe<Scalars['Decimal']>;
};

export type IShipping = {
  __typename?: 'Shipping';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The "Dimensional Weight" field represents the calculated weight of a package based on its dimensions, which is used to determine shipping costs. This value is particularly relevant for items with large dimensions but relatively low actual weight. */
  dimWeight?: Maybe<Scalars['Decimal']>;
  height?: Maybe<Scalars['Decimal']>;
  length?: Maybe<Scalars['Decimal']>;
  packageType?: Maybe<IPackageTypesEnum>;
  /** The "Rated Weight" of a product is a calculated attribute that indicates the estimated weight of the productand it is given by taking the max value between the dimensional weight and physical weight. */
  ratedWeight?: Maybe<Scalars['Decimal']>;
  shipReadyPackaging?: Maybe<Scalars['Boolean']>;
  shippingPackage?: Maybe<IShippingPackagesEnum>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The "Volume" field denotes the amount of space occupied by a product in three dimensions (length, width, height). */
  volume?: Maybe<Scalars['Decimal']>;
  weight?: Maybe<Scalars['Decimal']>;
  weightFactor?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Decimal']>;
};

/** This type represents a base shipping service which consists of a representation of both theservice and the associated carrier */
export type IShippingCarrierService = {
  __typename?: 'ShippingCarrierService';
  carrierLogo?: Maybe<Scalars['String']>;
  carrierName: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  serviceCountry: Scalars['String'];
  serviceName: Scalars['String'];
  serviceType: Scalars['String'];
  status: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Shipping packages */
export enum IShippingPackagesEnum {
  BubbleMailer = 'BUBBLE_MAILER',
  CorrugatedBox = 'CORRUGATED_BOX',
  Custom = 'CUSTOM',
  FlatRateBox = 'FLAT_RATE_BOX',
  PaddedEnvelope = 'PADDED_ENVELOPE',
  Polymailer_2 = 'POLYMAILER_2',
  SmallCardboardBox = 'SMALL_CARDBOARD_BOX',
  WoodenCrate = 'WOODEN_CRATE'
}

/** Autogenerated input type of SignIn */
export type ISignInInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** A login identifier used to log in to the app. Usually an email address. */
  loginIdentifier: Scalars['String'];
  /** The type of the login identifier. Defaults to `EMAIL`. */
  loginIdentifierType?: InputMaybe<ILoginIdentifierTypesEnum>;
  /** The unique secret password of the user. */
  password: Scalars['String'];
};

/** Autogenerated return type of SignIn. */
export type ISignInPayload = {
  __typename?: 'SignInPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /**
   * Returns the Bearer token to send in the `Authorization` header. Format this value as this:
   * `"Authorization": "Bearer {TOKEN}"`
   *
   */
  token: Scalars['String'];
  /** Expiration date time of the session token. */
  tokenExpiration: Scalars['ISO8601DateTime'];
  /** Logged user data. */
  user: IUser;
};

/** Autogenerated input type of SignOut */
export type ISignOutInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of SignOut. */
export type ISignOutPayload = {
  __typename?: 'SignOutPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** To acknowledge successful sign-out */
  message?: Maybe<Scalars['String']>;
  /** Status of the request to sign out the current user. */
  status?: Maybe<IStatusResultEnum>;
};

/** Autogenerated input type of SignUp */
export type ISignUpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Last name of the person associated with the account. */
  lastName?: InputMaybe<Scalars['String']>;
  /**
   * A valid identifier to login into the new account.
   * e.g. `email@example.com`
   */
  loginIdentifier: Scalars['String'];
  /**
   * The type of the identifier to login into the new account.
   * e.g. `EMAIL`
   */
  loginIdentifierType?: InputMaybe<ILoginIdentifierTypesEnum>;
  /** Name of the person associated with the account */
  name: Scalars['String'];
  /** A password used to login into the new account. */
  password: Scalars['String'];
};

/** Autogenerated return type of SignUp. */
export type ISignUpPayload = {
  __typename?: 'SignUpPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** To acknowledge successful sign-up */
  message?: Maybe<Scalars['String']>;
  /** Status of the request to create the account. */
  requestStatus?: Maybe<Scalars['String']>;
};

/** A size */
export type ISize = {
  __typename?: 'Size';
  brand: IBrand;
  createdAt: Scalars['ISO8601DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  status: IProductStatusEnum;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Sort type */
export enum ISortTypeEnum {
  /** Ascending */
  Asc = 'ASC',
  /** Descending */
  Desc = 'DESC'
}

/** Autogenerated input type of StartASNReceiving */
export type IStartAsnReceivingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the ASN to transition to the 'RECEIVING' status */
  id: Scalars['ID'];
};

/** Autogenerated input type of StartForgotPassword */
export type IStartForgotPasswordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** User registered email address. */
  email: Scalars['Email'];
};

/** Autogenerated return type of StartForgotPassword. */
export type IStartForgotPasswordPayload = {
  __typename?: 'StartForgotPasswordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  status: IStatusResultEnum;
};

/** A state */
export type IState = {
  __typename?: 'State';
  /** The country field indicates the country object to which the state belongs to. */
  country: ICountry;
  /** The countryCode fields indicates the country to which the state belongs to. */
  countryCode: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  /** The "ISO 2" field denotes the two-letter state code assigned by the International Organization for Standardization (ISO). */
  iso2: Scalars['String'];
  name: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Filter countries by name, ISO 2 code, or ISO 3 code */
export type IStateFiltersInput = {
  /** The keyword to search for in the state's name or ISO 2 code */
  keyword?: InputMaybe<Scalars['String']>;
  /** The field to sort countries by */
  sortBy?: InputMaybe<IStateSortByEnum>;
  /** The direction to sort countries by */
  sortType?: InputMaybe<ISortTypeEnum>;
};

export enum IStateSortByEnum {
  /** Name */
  Country = 'COUNTRY',
  /** Name */
  CreatedDate = 'CREATED_DATE',
  /** Name */
  Iso2 = 'ISO2',
  /** Name */
  Name = 'NAME',
  /** Name */
  UpdatedDate = 'UPDATED_DATE'
}

export enum IStatusEnum {
  /** Element is active */
  Active = 'ACTIVE',
  /** Element is inactive */
  Inactive = 'INACTIVE'
}

/** The response of a mutation that only returns a status */
export type IStatusResponse = {
  __typename?: 'StatusResponse';
  /** The status of the mutation */
  status: IStatusResultEnum;
};

/** The status of a mutation */
export enum IStatusResultEnum {
  /** The mutation failed */
  Error = 'ERROR',
  /** The mutation is still processing */
  Processing = 'PROCESSING',
  /** The mutation was successful */
  Success = 'SUCCESS'
}

/** A size */
export type IStyle = {
  __typename?: 'Style';
  brand: IBrand;
  children: Array<IStyle>;
  createdAt: Scalars['ISO8601DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  parent?: Maybe<IStyle>;
  status: IProductStatusEnum;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type ISubscription = {
  __typename?: 'Subscription';
  /** Subscription for receiving updates on ASNs. Updates delivered through this subscription include changes to an specific ASN. */
  asnUpdates: ISubscriptionUpdatesPayload;
  /** Subscription for receiving updates on ASNs for a Brand. Updates delivered through this subscription include new ASNs, updates to existing ASNs, and deletions of ASNs. */
  brandAsnUpdates: ISubscriptionUpdatesPayload;
  /** Subscription to retrieve notifications for order list updates.Requires the user is logged in and user be authorized to subscribe to order list updates. */
  brandOrderUpdates: IOrderUpdatesPayload;
  /** Subscription for receiving updates on ASNs for a Company. Updates delivered through this subscription include new ASNs, updates to existing ASNs, and deletions of ASNs. */
  companyAsnUpdates: ISubscriptionUpdatesPayload;
  /** Subscription to retrieve notifications for order list updates for a specific company.Requires the user is logged in and user be authorized to subscribe to order list updates. */
  companyOrderUpdates: IOrderUpdatesPayload;
  /** Subscription to retrieve the order updates.Requires the user is logged in and user be authorized to subscribe to order updates. */
  orderUpdates: IOrderUpdatesPayload;
  /** Subscription to retrieve the warehouse updates.Requires the user is logged in and user be authorized to subscribe to warehouse updates. */
  warehouseUpdates: IWarehouse;
};


export type ISubscriptionAsnUpdatesArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type ISubscriptionBrandAsnUpdatesArgs = {
  brandId?: InputMaybe<Scalars['ID']>;
};


export type ISubscriptionBrandOrderUpdatesArgs = {
  brandId?: InputMaybe<Scalars['ID']>;
};


export type ISubscriptionCompanyAsnUpdatesArgs = {
  companyId?: InputMaybe<Scalars['ID']>;
};


export type ISubscriptionCompanyOrderUpdatesArgs = {
  companyId?: InputMaybe<Scalars['ID']>;
};


export type ISubscriptionOrderUpdatesArgs = {
  orderId: Scalars['ID'];
};


export type ISubscriptionWarehouseUpdatesArgs = {
  warehouseId: Scalars['ID'];
};

export enum ISubscriptionObjectTypeEnum {
  /** ASN */
  Asn = 'ASN',
  /** ASN Line Item */
  AsnLineItem = 'ASN_LINE_ITEM',
  /** Brand */
  Brand = 'BRAND',
  /** Integration */
  Integration = 'INTEGRATION',
  /** Inventory Item */
  InventoryItem = 'INVENTORY_ITEM',
  /** Location */
  Location = 'LOCATION',
  /** Note */
  Note = 'NOTE',
  /** Order */
  Order = 'ORDER',
  /** Order Line Item */
  OrderLineItem = 'ORDER_LINE_ITEM',
  /** Product */
  Product = 'PRODUCT',
  /** Warehouse */
  Warehouse = 'WAREHOUSE'
}

export type ISubscriptionUpdatesPayload = {
  __typename?: 'SubscriptionUpdatesPayload';
  /** Additional data related to the event. */
  changesSummary?: Maybe<Scalars['JSON']>;
  /** The event that occurred. */
  event?: Maybe<Scalars['String']>;
  /** The ID of the object that was updated. */
  updatedObjectId?: Maybe<Scalars['ID']>;
  /** The type of object that was updated. */
  updatedObjectType?: Maybe<ISubscriptionObjectTypeEnum>;
};

/** Autogenerated input type of SyncASNInventory */
export type ISyncAsnInventoryInput = {
  /** Contains the ASN id(s) */
  asnIds: Array<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of SyncASNInventory. */
export type ISyncAsnInventoryPayload = {
  __typename?: 'SyncASNInventoryPayload';
  asnIds: Array<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  status: IStatusResultEnum;
};

export enum ISyncDirectionEnum {
  /** Sync products in both directions. */
  Bidirectional = 'BIDIRECTIONAL',
  /** Sync products from the external source to MvnifestAI. */
  FromExternal = 'FROM_EXTERNAL',
  /** Sync products from MvnifestAI to the external source. */
  ToExternal = 'TO_EXTERNAL'
}

/** Autogenerated input type of SyncInventory */
export type ISyncInventoryInput = {
  /** The ID of the brand that the desired sync should be performed on.If no brand is given, then the context brand will be used. */
  brandId?: InputMaybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the integration to sync products with. If not provided, all integrations will be used. */
  integrationId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of SyncInventory. */
export type ISyncInventoryPayload = {
  __typename?: 'SyncInventoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The ID of the sync operation. This ID can be used to receive the status of the operation via a subscription. */
  syncId?: Maybe<Scalars['ID']>;
};

/** Autogenerated input type of SyncProducts */
export type ISyncProductsInput = {
  /** The ID of the brand to sync products with. If not provided, the system will use the brand specified in the current context. If no brand is specified in the context, the operation will fail returning a `BadRequest` error. */
  brandId?: InputMaybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** If set to true, missing products will be created locally or in the external source based on the direction of the sync operation. Be careful when using this option, it can lead to data inconsistency. */
  createMissing?: InputMaybe<Scalars['Boolean']>;
  /** The direction of the sync operation. Possible values are: FROM_EXTERNAL, TO_EXTERNAL. Default value is BIDIRECTIONAL. */
  direction?: InputMaybe<ISyncDirectionEnum>;
  /** The ID of the integration to sync products with. If not provided, all integrations will be used. */
  integrationId?: InputMaybe<Scalars['ID']>;
  /** The list of product IDs to sync. If not provided, all products will be synced. */
  productIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** Autogenerated return type of SyncProducts. */
export type ISyncProductsPayload = {
  __typename?: 'SyncProductsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The ID of the sync operation. This ID can be used to receive the status of the operation vía a subscription. */
  syncId?: Maybe<Scalars['ID']>;
};

/** The SystemLogType object represents a system log entry. It includes fields for the log type (info, error, warning, success), the operation performed, the message associated with the log entry, the ID and type of the entity associated with the log entry, and timestamps for when the log entry was created and updated. */
export type ISystemLog = {
  __typename?: 'SystemLog';
  /** The date and time when the log entry was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The ID of the entity associated with the log entry. */
  entityId: Scalars['ID'];
  /** The type of the entity associated with the log entry. */
  entityType: ILogEntityTypeEnum;
  /** The unique identifier for the log entry. */
  id: Scalars['ID'];
  /** The type of the log entry. Can be `INFO`, `ERROR`, `WARNING`, or `SUCCESS`. */
  logType: ILogTypeEnum;
  /** The message associated with the log entry. */
  message: Scalars['String'];
  /** The operation that was performed when the log entry was created. */
  operation: Scalars['String'];
  /** The party that performed the operation associated with the log entry. */
  performer?: Maybe<ILogsPerformer>;
  /** The date and time when the log entry was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/**
 * The `SystemLogFilterInput` object is used to filter the results of the SystemLog query. Each field corresponds to a specific attribute in the log entries and is optional. If a field is provided, the query will return only the log entries that match the provided value for that field.
 *
 * | Field | Type | Description |
 * | --- | --- | --- |
 * | `log_type` | String | Type of the log entry. Can be `INFO`, `ERROR`, `WARNING`, or `SUCCESS`. |
 * | `operation` | String | Operation that was performed when the log entry was created. |
 * | `entity_id` | ID | ID of the entity associated with the log entry. |
 * | `entity_type` | String | Type of the entity associated with the log entry. |
 * | `start_date` | DateTime | Start date for filtering the log entries. Only entries created after this date will be returned. |
 * | `end_date` | DateTime | End date for filtering the log entries. Only entries created before this date will be returned. |
 */
export type ISystemLogFilterInput = {
  /** Filter by `end_date`. This field is used to filter the log entries by the date and time they were created. Only log entries created before the `end_date` will be returned. */
  endDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Filter by `entity_id`. This field corresponds to the `entity_id` column in the `sys_logs` table. The value is the ID of the entity associated with the log entry. */
  entityId: Scalars['ID'];
  /** Filter by `entity_type`. This field corresponds to the `entity_type` column in the `sys_logs` table. The value is the type of the entity associated with the log entry. */
  entityType: ILogEntityTypeEnum;
  /** Filter by `log_type`. This field corresponds to the `log_type` column in the `sys_logs` table. The value can be `INFO`, `ERROR`, `WARNING`, or `SUCCESS`. */
  logType?: InputMaybe<ILogTypeEnum>;
  /** Filter by `operation`. This field corresponds to the `operation` column in the `sys_logs` table. The value is the operation that was performed when the log entry was created. */
  operation?: InputMaybe<Scalars['String']>;
  /** Filter by `start_date`. This field is used to filter the log entries by the date and time they were created. Only log entries created after the `start_date` will be returned. */
  startDate?: InputMaybe<Scalars['ISO8601DateTime']>;
};

export type ITransferItem = {
  __typename?: 'TransferItem';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  inventoryItem: IInventoryItem;
  inventoryItemId: Scalars['ID'];
  inventoryTransfer: IInventoryTransfer;
  inventoryTransferId: Scalars['ID'];
  quantity: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export enum ITransferStatusEnum {
  /** Transfer canceled */
  Canceled = 'CANCELED',
  /** Transfer completed */
  Completed = 'COMPLETED',
  /** Transfer Initialized */
  Initialized = 'INITIALIZED',
  /** Transfer in progress */
  InProgress = 'IN_PROGRESS'
}

/** Autogenerated input type of UnassignRole */
export type IUnassignRoleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The domain to remove the role from. The domain can be SYSTEM, COMPANY or BRAND. */
  domain?: InputMaybe<IDomainEnum>;
  /** The ID of the domain entity to remove the role from. This argument is only required if the domain is COMPANY or BRAND */
  domainEntityId?: InputMaybe<Scalars['ID']>;
  /** The ID of the party to remove the role from. */
  partyId: Scalars['ID'];
  /** The ID of the role to remove. */
  roleId: Scalars['ID'];
};

/** Autogenerated input type of UnfulfillOrder */
export type IUnfulfillOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderId: Scalars['ID'];
};

/** Autogenerated input type of UnshipOrder */
export type IUnshipOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the order to unship. */
  orderId: Scalars['ID'];
};

/** Autogenerated return type of UnshipOrder. */
export type IUnshipOrderPayload = {
  __typename?: 'UnshipOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The ID of the order that was unshipped. */
  orderId: Scalars['ID'];
  /** The result of the unship operation. This will be 'SUCCESS' if the order was successfully unshipped. A `SUCCESS` results does not indicate that the order was successfully unshipped but the request was received by the system and it is being processed. */
  resultStatus: IStatusResultEnum;
};

/** Autogenerated input type of UpdateASN */
export type IUpdateAsnInput = {
  /** The ID of the ASN to update. */
  asnId: Scalars['ID'];
  /** The items for the ASN. If you want to remove an item, set the `delete` field to `true`. */
  asnItems?: InputMaybe<Array<IAsnItemInput>>;
  /** The type of ASN. */
  asnType?: InputMaybe<IAsnTypeEnum>;
  /** The carrier type for the ASN. */
  carrierType?: InputMaybe<IAsnCarrierTypeEnum>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The expected arrival date for the ASN. */
  expectedArrivalDate?: InputMaybe<Scalars['ISO8601Date']>;
  /** The PO number for the ASN. */
  poNumber?: InputMaybe<Scalars['String']>;
  /** The ship date for the ASN. */
  shipDate?: InputMaybe<Scalars['ISO8601Date']>;
  /** The shipping carrier service for the ASN. */
  shippingCarrierService?: InputMaybe<Scalars['String']>;
  /** The tracking number for the ASN. This tracking number must be unique in the brand context. */
  trackingNumber?: InputMaybe<Scalars['String']>;
  /** The destination warehouse ID for the ASN. */
  warehouseId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated input type of UpdateApiClient */
export type IUpdateApiClientInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The type of client. */
  clientType?: InputMaybe<IApiClientTypeEnum>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateApiKey */
export type IUpdateApiKeyInput = {
  /** The date and time when the API key will expire. If not provided, the API key will never expire. */
  activeUntil?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The list of authorized hosts for the API key. This option only applies to API clients that are web applications. */
  authorizedHosts?: InputMaybe<Array<Scalars['Domain']>>;
  /** The list of authorized IP addresses for the API key. This option only applies to API clients that are server-side applications. */
  authorizedIps?: InputMaybe<Array<Scalars['IpAddress']>>;
  /** The base URL for the API client. Emails notifications and other communications will use this URL as base for links. */
  baseUrl?: InputMaybe<Scalars['Url']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the API key to update. */
  id: Scalars['ID'];
  /** A descriptive name for the API key. */
  name?: InputMaybe<Scalars['String']>;
  /** The status of the API key. */
  status?: InputMaybe<IStatusEnum>;
};

/** Autogenerated input type of UpdateBrand */
export type IUpdateBrandInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  /** The ID of the fulfillment integration to use for the brand. */
  fulfillmentIntegrationId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  logoUrl?: InputMaybe<Scalars['Url']>;
  name?: InputMaybe<Scalars['String']>;
  /** The ID of the person responsible for the brand. */
  responsibleId?: InputMaybe<Scalars['ID']>;
  /** The ID of the default warehouse for the brand. This warehouse will be used by default for order fulfillment. */
  warehouseId?: InputMaybe<Scalars['ID']>;
  websiteUrl?: InputMaybe<Scalars['Url']>;
};

/** Autogenerated input type of UpdateIntegration */
export type IUpdateIntegrationInput = {
  /** The API key for the integration. This argument can be also used to store the main API key or secret for the integration. It is very important to store the main connection credential using this argument because it will be encrypted and stored in the database. */
  apiKey?: InputMaybe<Scalars['String']>;
  /** The API secret for the integration. This argument will be encrypted and stored in the database. */
  apiSecret?: InputMaybe<Scalars['String']>;
  /** The API token for the integration. This argument will be encrypted and stored in the database. */
  apiToken?: InputMaybe<Scalars['String']>;
  /** The brand id. If the header `X-Brand-Id` is provided then this argument is optional, otherwise it is required. */
  brandId?: InputMaybe<Scalars['ID']>;
  carrierMapping?: InputMaybe<Scalars['JSON']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  integrationId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  /** Additional settings for the integration. This argument can be used to store any additional settings for the integration different from the api_key, the api_secret or the api_token. */
  settings?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<IStatusEnum>;
};

/** Autogenerated input type of UpdateMyProfile */
export type IUpdateMyProfileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

/** Autogenerated input type of UpdateOrder */
export type IUpdateOrderInput = {
  billToCompany?: InputMaybe<Scalars['String']>;
  billToEmail?: InputMaybe<Scalars['String']>;
  billToName?: InputMaybe<Scalars['String']>;
  billToPhone?: InputMaybe<Scalars['String']>;
  billingAddress?: InputMaybe<IAddressInput>;
  brandId?: InputMaybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  expectedDeliveryDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  expectedShipDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The financial status of the order. */
  financialStatus?: InputMaybe<IOrderFinancialStatusEnum>;
  notes?: InputMaybe<Array<INoteInput>>;
  orderId: Scalars['ID'];
  orderItems?: InputMaybe<Array<IOrderItemInput>>;
  responsibleId?: InputMaybe<Scalars['ID']>;
  salesChannelId?: InputMaybe<Scalars['ID']>;
  /** The carrier that will be used to ship the order. */
  selectedCarrierId?: InputMaybe<Scalars['ID']>;
  /** The carrier service that will be used to ship the order. */
  selectedCarrierServiceId?: InputMaybe<Scalars['ID']>;
  shipToCompany?: InputMaybe<Scalars['String']>;
  shipToEmail?: InputMaybe<Scalars['String']>;
  shipToName?: InputMaybe<Scalars['String']>;
  shipToPhone?: InputMaybe<Scalars['String']>;
  shipToSameAsBillTo?: InputMaybe<Scalars['Boolean']>;
  shippingAddress?: InputMaybe<IAddressInput>;
  shippingCarrierService?: InputMaybe<Scalars['String']>;
  /** The shipping cost paid by the customer. */
  shippingCost?: InputMaybe<Scalars['Decimal']>;
  tags?: InputMaybe<Array<IOrderTagInput>>;
  /** The total tax paid by the customer. */
  totalTax?: InputMaybe<Scalars['Decimal']>;
};

/** Autogenerated input type of UpdateOrderItem */
export type IUpdateOrderItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the order item to update */
  id: Scalars['ID'];
  /** New price of the order item */
  price?: InputMaybe<Scalars['Decimal']>;
  /** New quantity of the order item */
  quantity?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of UpdateProduct */
export type IUpdateProductInput = {
  /** The ID of the brand to which this product belongs. If not provided, the current brand will be used. */
  brandId?: InputMaybe<Scalars['ID']>;
  /** The bullet points for this product. Bullet points are used to describe the product on the website. */
  bulletPoints?: InputMaybe<Array<Scalars['String']>>;
  /** The IDs of the categories to which this product belongs. */
  categories?: InputMaybe<Array<Scalars['ID']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  colorId?: InputMaybe<Scalars['ID']>;
  customsInput?: InputMaybe<IProductCustomsInput>;
  description?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Decimal']>;
  images?: InputMaybe<Array<IProductImageInput>>;
  /** Whether this product has an inner pack. If true, the inner pack data must be provided. */
  innerPack?: InputMaybe<Scalars['Boolean']>;
  innerPackInput?: InputMaybe<IProductInnerPackInput>;
  length?: InputMaybe<Scalars['Decimal']>;
  /** Whether this product has a master carton. If true, the master carton data must be provided. */
  masterCarton?: InputMaybe<Scalars['Boolean']>;
  masterCartonInput?: InputMaybe<IProductMasterCartonInput>;
  name?: InputMaybe<Scalars['String']>;
  /** Whether this product has a pallet. If true, the pallet data must be provided. */
  pallet?: InputMaybe<Scalars['Boolean']>;
  palletInput?: InputMaybe<IProductPalletInput>;
  /** The ID of the parent product. If provided, this product will be a variant of the parent product. */
  parentId?: InputMaybe<Scalars['ID']>;
  price?: InputMaybe<Scalars['Decimal']>;
  productId: Scalars['ID'];
  /** The type of product. If not provided, defaults to 'BASE_ITEM'. */
  productType?: InputMaybe<IProductTypeEnum>;
  purchasingInput?: InputMaybe<IProductPurchasingInput>;
  /** Whether this product is shippable. If false, the product will not be available for purchase. */
  ship?: InputMaybe<Scalars['Boolean']>;
  shippingInput?: InputMaybe<IProductShippingInput>;
  sizeId?: InputMaybe<Scalars['ID']>;
  sku?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<IProductStatusEnum>;
  styleId?: InputMaybe<Scalars['ID']>;
  upc?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Decimal']>;
  width?: InputMaybe<Scalars['Decimal']>;
};

/** Autogenerated input type of UpdateSalesChannel */
export type IUpdateSalesChannelInput = {
  /** Whether orders from this sales channel should be automatically fulfilled. */
  autoFulfill?: InputMaybe<Scalars['Boolean']>;
  channelType?: InputMaybe<ISalesChannelTypeEnum>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  customPackingSlip?: InputMaybe<Scalars['Boolean']>;
  /** Whether this is the default sales channel for the brand. If this options is set to true, the default sales channel for the brand will be updated. */
  defaultChannel?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Sales channels can be integrated with external systems. This ID represents an integration already configured in the system. */
  integrationId?: InputMaybe<Scalars['ID']>;
  /** Whether the routing strategy is local or global. If this value is set to true, Endless Commerce will manage the routing for orders from this sales channel. If this value is set to false, the routing strategy will be managed by the external system integrated with Endless Commerce. */
  localRouting?: InputMaybe<Scalars['Boolean']>;
  logoUrl?: InputMaybe<Scalars['Url']>;
  name?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<ISalesChannelOriginEnum>;
  /** The routing strategy to be used for this sales channel. If not provided, the default routing strategy will be used. */
  routingStrategy?: InputMaybe<Array<IRoutingStrategyEnum>>;
  status?: InputMaybe<IStatusEnum>;
};

/** Autogenerated input type of UpdateWarehouse */
export type IUpdateWarehouseInput = {
  /** The address of the warehouse as a structured input. */
  address?: InputMaybe<IAddressInput>;
  brandId?: InputMaybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the company that owns the warehouse. Performer must be a member of the company and be allowed to register a warehouse for it. */
  companyId?: InputMaybe<Scalars['ID']>;
  /** External data associated with the warehouse. */
  externalData?: InputMaybe<IWarehouseExternalDataInput>;
  /** The ID of the fulfillment integration associated with the warehouse. */
  fulfillmentIntegrationId?: InputMaybe<Scalars['ID']>;
  /** The ID of the warehouse to update. */
  id: Scalars['ID'];
  /** The name of the warehouse. */
  name?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Int']>;
  /** Whether the warehouse is a residential building, such as a house or apartment. */
  residential?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<IStatusEnum>;
};

export type IUser = {
  __typename?: 'User';
  createdAt: Scalars['ISO8601DateTime'];
  emails?: Maybe<Array<Scalars['Email']>>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastLoginAt?: Maybe<Scalars['ISO8601DateTime']>;
  lastName?: Maybe<Scalars['String']>;
  /** The party associated with this user account */
  party?: Maybe<IParty>;
  primaryEmail?: Maybe<Scalars['Email']>;
  updatedAt: Scalars['ISO8601DateTime'];
  verified: Scalars['Boolean'];
};

/** Autogenerated input type of VerifyAccount */
export type IVerifyAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** A verification token included in the message sent in the verification message. Usually in the form of a link. */
  token: Scalars['String'];
};

/** Autogenerated return type of VerifyAccount. */
export type IVerifyAccountPayload = {
  __typename?: 'VerifyAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The recently verified login identifier. */
  loginIdentifier?: Maybe<Scalars['String']>;
  /** The type of login identifier verified. */
  loginIdentifierType?: Maybe<ILoginIdentifierTypesEnum>;
  /** Result of the attempt to verification. A successful response means that the login identifier was verified. */
  status: Scalars['String'];
};

/** A warehouse */
export type IWarehouse = {
  __typename?: 'Warehouse';
  /** The "Address" field denotes the address of the warehouse. */
  address?: Maybe<IAddress>;
  brand?: Maybe<IBrand>;
  brandId?: Maybe<Scalars['ID']>;
  /** The "Company" field denotes the company that owns the warehouse. The company represents a party in the system. */
  company: IParty;
  companyId: Scalars['ID'];
  createdAt: Scalars['ISO8601DateTime'];
  /** The "Deleted At" field denotes the date and time that the warehouse was deleted. If the warehouse has not been deleted, this field will be null. */
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The "External Data" field denotes the external data that is stored with the warehouse. */
  externalData?: Maybe<Array<IWarehouseExternalData>>;
  /** The fulfillment integration used by the warehouse. */
  fulfillmentIntegration?: Maybe<IIntegration>;
  id: Scalars['ID'];
  name: Scalars['String'];
  /** This field defines the priority of the warehouse for fulfillment and routing. Warehouses with a lower priority are preferred over warehouses with a higher priority. */
  priority?: Maybe<Scalars['Int']>;
  /** The "Residential" field denotes whether the warehouse is a residential address. This information aids in determining the shipping method of an order. */
  residential: Scalars['Boolean'];
  status: IStatusEnum;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for Warehouse. */
export type IWarehouseConnection = {
  __typename?: 'WarehouseConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IWarehouseEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IWarehouse>>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** Total count of items in the connection, without considering pagination. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type IWarehouseEdge = {
  __typename?: 'WarehouseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<IWarehouse>;
};

/** External data stored with the warehouse. */
export type IWarehouseExternalData = {
  __typename?: 'WarehouseExternalData';
  /** The ID of the warehouse in the external system. */
  externalId: Scalars['String'];
  /** The type of the external system that provides the data. */
  externalType: IExternalTypeEnum;
  id: Scalars['ID'];
  /** The external system that provides the data. */
  integration: IIntegration;
  /** The ID of the external system that provides the data. */
  integrationId: Scalars['ID'];
  /** Additional metadata stored with the external data. */
  metadata?: Maybe<Scalars['JSON']>;
};

/** External data to be stored with the warehouse. */
export type IWarehouseExternalDataInput = {
  /** The ID of the warehouse in the external system. */
  externalId?: InputMaybe<Scalars['String']>;
  /** The type of the external system that provides the data. Warehouses with type 'OWNED' are managed by Endless Commerce. */
  externalType?: InputMaybe<IExternalTypeEnum>;
  /** The ID of the external system that provides the data. */
  integrationId: Scalars['ID'];
  /** Additional metadata to be stored with the external data. */
  metadata?: InputMaybe<Scalars['JSON']>;
};

export enum IWarehouseSortFieldsEnum {
  /** Sort by city */
  City = 'CITY',
  /** Sort by country code */
  CountryCode = 'COUNTRY_CODE',
  /** Sort by creation date */
  CreatedAt = 'CREATED_AT',
  /** Sort by name */
  Name = 'NAME',
  /** Sort by postal code */
  PostalCode = 'POSTAL_CODE',
  /** Sort by priority */
  Priority = 'PRIORITY',
  /** Sort by residential */
  Residential = 'RESIDENTIAL',
  /** Sort by state code */
  StateCode = 'STATE_CODE',
  /** Sort by status */
  Status = 'STATUS',
  /** Sort by update date */
  UpdatedAt = 'UPDATED_AT'
}

export enum IZoneEnum {
  /** Bulk */
  Bulk = 'BULK',
  /** External */
  External = 'EXTERNAL',
  /** Kitting */
  Kitting = 'KITTING',
  /** Picking */
  Picking = 'PICKING',
  /** Quarantine */
  Quarantine = 'QUARANTINE',
  /** Receiving */
  Receiving = 'RECEIVING',
  /** Returns */
  Returns = 'RETURNS',
  /** Shipping */
  Shipping = 'SHIPPING',
  /** Wholesale */
  Wholesale = 'WHOLESALE'
}
